<template>
  <div class="MachStatus">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <b-col cols="1"></b-col>
        <b-col cols="10" class="px-0">
          <b-container class="bv-example-row px-0">
            <b-row class="mx-0">
              <b-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                class="px-0 text-right my-3"
                style="font-size: 1rem"
              >
                <span class="my-0" id="machStatus-now-time">更新時間:</span>
                <span class="my-0" for="machStatus-now-time">{{
                  nowtime
                }}</span>
              </b-col>
              <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="px-0">
                <template v-if="previousPage.pageStatus">
                  <div class="machStatus-place-button">
                    <p @click="toPreviousPage(), (tabIndex = 0), clearTimer()">
                      返回
                    </p>
                  </div>
                </template>
                <template v-else>
                  <router-link
                    :to="'elecboard'"
                    class="machStatus-place-button"
                  >
                    <p @click="clearTimer(), (tabIndex = 0)">返回</p>
                  </router-link>
                </template>
              </b-col>

              <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="px-0">
                <b-row class="mx-0">
                  <b-col cols="12" class="p-0 m-0 mt-3">
                    <b-row class="mx-0">
                      <b-col cols="12" class="p-0 m-0 mb-2">
                        <b-row class="mx-0">
                          <b-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="4"
                            xl="3"
                            class="p-0 m-0"
                          >
                            <div
                              style="width: 100%; height: 100%"
                              class="align-items-center"
                            >
                              <!-- src="../assets/CBF.jpg" -->
                              <img
                                :src="device_image"
                                class="mx-auto"
                                alt="Center image"
                                style="
                                  width: 100%;
                                  max-height: 8rem;
                                  object-fit: contain;
                                "
                              />
                            </div>
                          </b-col>
                          <b-col
                            v-if="main_query_check"
                            cols="12"
                            sm="12"
                            md="12"
                            lg="8"
                            xl="9"
                            class="p-0 m-0"
                          >
                            <b-row class="mx-0">
                              <b-col
                                cols="12"
                                class="p-0 mx-0"
                                style="margin-bottom: 2.3rem"
                              >
                                <b-row class="mx-0">
                                  <template
                                    v-if="sideBarSelect.process.name == '包裝'"
                                  >
                                    <b-col
                                      cols="4"
                                      sm="4"
                                      md="4"
                                      lg="4"
                                      xl="2"
                                      class="p-0 mb-1 text-left"
                                      style="line-height: 2rem"
                                    >
                                      <span class="m-0" style>製程:</span>
                                      <span class="m-0" style>{{
                                        device_detail.process
                                      }}</span>
                                    </b-col>
                                    <b-col
                                      cols="4"
                                      sm="4"
                                      md="4"
                                      lg="4"
                                      xl="6"
                                      class="p-0 mb-1 text-left"
                                      style="line-height: 2rem"
                                    >
                                      <span class="m-0" style>組別:</span>
                                      <span class="m-0" style
                                        >第{{ device_detail.group }}組</span
                                      >
                                    </b-col>
                                  </template>
                                  <template
                                    v-else-if="
                                      sideBarSelect.process.name == '出貨' &&
                                      shipment_process == '裝櫃-即時狀態'
                                    "
                                  >
                                    <b-col
                                      cols="4"
                                      sm="4"
                                      md="4"
                                      lg="4"
                                      xl="2"
                                      class="p-0 mb-1 text-left"
                                      style="line-height: 2rem"
                                    >
                                      <span class="m-0" style>作業:</span>
                                      <span class="m-0" style>{{
                                        device_detail.process
                                      }}</span>
                                    </b-col>
                                    <b-col
                                      cols="4"
                                      sm="4"
                                      md="4"
                                      lg="4"
                                      xl="2"
                                      class="p-0 mb-1 text-left"
                                      style="line-height: 2rem"
                                    >
                                      <span class="m-0" style>單位:</span>
                                      <span class="m-0" style>{{
                                        device_detail.department
                                      }}</span>
                                    </b-col>
                                    <b-col
                                      cols="4"
                                      sm="4"
                                      md="4"
                                      lg="4"
                                      xl="2"
                                      class="p-0 mb-1 text-left"
                                      style="line-height: 2rem"
                                    >
                                      <span class="m-0" style>車別:</span>
                                      <span class="m-0" style>{{
                                        device_detail.car_no
                                      }}</span>
                                    </b-col>
                                    <b-col
                                      cols="4"
                                      sm="4"
                                      md="4"
                                      lg="4"
                                      xl="2"
                                      class="p-0 mb-1 text-left"
                                      style="line-height: 2rem"
                                    >
                                      <span class="m-0" style>操作人員:</span>
                                      <span class="m-0" style>{{
                                        device_detail.operator
                                      }}</span>
                                    </b-col>
                                  </template>
                                  <template
                                    v-else-if="
                                      sideBarSelect.process.name == '出貨' &&
                                      shipment_process == '齊貨狀態'
                                    "
                                  >
                                  </template>
                                  <template v-else>
                                    <b-col
                                      cols="4"
                                      sm="4"
                                      md="4"
                                      lg="4"
                                      xl="2"
                                      class="p-0 mb-1 text-left"
                                      style="line-height: 2rem"
                                    >
                                      <span class="m-0" style>製程:</span>
                                      <span class="m-0" style>{{
                                        device_detail.process
                                      }}</span>
                                    </b-col>
                                    <b-col
                                      cols="4"
                                      sm="4"
                                      md="4"
                                      lg="4"
                                      xl="2"
                                      class="p-0 mb-1 text-left"
                                      style="line-height: 2rem"
                                    >
                                      <span class="m-0" style>產線:</span>
                                      <span class="m-0" style>{{
                                        device_detail.group
                                      }}</span>
                                    </b-col>
                                    <b-col
                                      cols="4"
                                      sm="4"
                                      md="4"
                                      lg="4"
                                      xl="2"
                                      class="p-0 mb-1 text-left"
                                      style="line-height: 2rem"
                                    >
                                      <span class="m-0" style>機號:</span>
                                      <span class="m-0" style>{{
                                        device_detail.device_name
                                      }}</span>
                                    </b-col>
                                    <b-col
                                      cols="4"
                                      sm="4"
                                      md="4"
                                      lg="4"
                                      xl="2"
                                      class="p-0 mb-1 text-left"
                                      style="line-height: 2rem"
                                    >
                                      <span class="m-0" style>型號:</span>
                                      <span class="m-0" style>{{
                                        device_detail.device_model
                                      }}</span>
                                    </b-col>
                                  </template>
                                  <b-col
                                    cols="12"
                                    sm="8"
                                    md="8"
                                    lg="8"
                                    xl="4"
                                    class="p-0 mb-1 text-right"
                                    style="line-height: 2rem"
                                  >
                                    <span
                                      class="m-0"
                                      style
                                      v-if="
                                        sideBarSelect.process.name == '出貨' &&
                                        shipment_process == '齊貨狀態'
                                      "
                                    ></span>
                                    <span class="m-0" style v-else>狀態:</span>
                                    <span class="m-0" style>
                                      <template
                                        v-if="
                                          sideBarSelect.process.name == '熱處理'
                                        "
                                      >
                                        <template
                                          v-if="
                                            device_detail.machine_status == 'R'
                                          "
                                        >
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #00b152;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            運轉
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            關機
                                          </div>
                                        </template>
                                        <template
                                          v-else-if="
                                            device_detail.machine_status == 'M'
                                          "
                                        >
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            運轉
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccdfe;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            維修
                                          </div>
                                        </template>
                                        <template
                                          v-else-if="
                                            device_detail.machine_status == 'H'
                                          "
                                        >
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            運轉
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            關機
                                          </div>
                                        </template>
                                        <template v-else>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            運轉
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            關機
                                          </div>
                                        </template>
                                      </template>
                                      <template
                                        v-else-if="
                                          sideBarSelect.process.name ==
                                            '出貨' &&
                                          shipment_process == '裝櫃-即時狀態'
                                        "
                                      >
                                        <template
                                          v-if="device_detail.status == 'R'"
                                        >
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #00b152;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            裝櫃
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            離線
                                          </div>
                                        </template>
                                        <template v-else>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            裝櫃
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            離線
                                          </div>
                                        </template>
                                      </template>
                                      <template
                                        v-else-if="
                                          sideBarSelect.process.name ==
                                            '出貨' &&
                                          shipment_process == '齊貨狀態'
                                        "
                                      ></template>
                                      <template v-else>
                                        <template
                                          v-if="
                                            device_detail.machine_status == 'R'
                                          "
                                        >
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #00b152;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            運轉
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            待機
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            異常
                                          </div>
                                        </template>
                                        <template
                                          v-else-if="
                                            device_detail.machine_status == 'Q'
                                          "
                                        >
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            運轉
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #ffc100;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            待機
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            異常
                                          </div>
                                        </template>
                                        <template
                                          v-else-if="
                                            device_detail.machine_status == 'H'
                                          "
                                        >
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            運轉
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            待機
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #c10000;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            異常
                                          </div>
                                        </template>
                                        <template
                                          v-else-if="
                                            device_detail.machine_status == 'M'
                                          "
                                        >
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            運轉
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccdfe;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            維修
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            異常
                                          </div>
                                        </template>
                                        <template
                                          v-else-if="
                                            device_detail.machine_status == 'D'
                                          "
                                        >
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            運轉
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #09b0ff;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            調車
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            異常
                                          </div>
                                        </template>
                                        <template
                                          v-else-if="
                                            device_detail.machine_status == 'I'
                                          "
                                        >
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #99f98c;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            短寸
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            待機
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            異常
                                          </div>
                                        </template>
                                        <template v-else>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            運轉
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            待機
                                          </div>
                                          <div
                                            style="
                                              display: inline-block;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              padding: 0px 13px;
                                              width: 4.25rem;
                                              height: 2rem;
                                              line-height: 2rem;
                                              font-size: 1.125rem;
                                              font-family: dfyuanstd-w7,
                                                dfyuanstd-w5;
                                              text-align: center;
                                              margin: 0 0 0 0.5rem;
                                              font-weight: normal;
                                            "
                                          >
                                            異常
                                          </div>
                                        </template>
                                      </template>
                                    </span>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>

                            <b-row class="mx-0">
                              <b-col cols="12" class="p-0 m-0 mb-2">
                                <div
                                  v-if="
                                    sideBarSelect.process.name == '出貨' &&
                                    shipment_process == '齊貨狀態'
                                  "
                                >
                                  <b-input-group prepend="">
                                    <b-form-input
                                      aria-label="Last name"
                                      disabled
                                      :value="'客戶：' + device_detail.cu_id"
                                      style="min-width: 135px"
                                    ></b-form-input>
                                    <b-form-input
                                      aria-label="Last name"
                                      disabled
                                      :value="
                                        '預計出貨日：' + device_detail.ship_date
                                      "
                                      style="min-width: 135px"
                                    ></b-form-input>
                                    <b-form-input
                                      aria-label="Last name"
                                      disabled
                                      :value="'單號：' + device_detail.ord_code"
                                      style="min-width: 135px"
                                    ></b-form-input>
                                    <b-form-input
                                      aria-label="Last name"
                                      disabled
                                      :value="'櫃號：' + device_detail.cno"
                                      style="min-width: 135px"
                                    ></b-form-input>
                                  </b-input-group>
                                  <b-input-group prepend="" class="mb-2">
                                    <b-form-input
                                      aria-label="Last name"
                                      disabled
                                      :value="
                                        'OG總重量(KG)：' + device_detail.ta_wgt
                                      "
                                      style="min-width: 135px"
                                    ></b-form-input>
                                    <b-form-input
                                      aria-label="Last name"
                                      disabled
                                      :value="
                                        '未入庫重量(KG)：' +
                                        device_detail.unstock_wgt
                                      "
                                      style="min-width: 135px"
                                    ></b-form-input>
                                    <b-form-input
                                      aria-label="Last name"
                                      disabled
                                      :value="'總板數：' + device_detail.pallet"
                                      style="min-width: 135px"
                                    ></b-form-input>
                                    <b-form-input
                                      aria-label="Last name"
                                      disabled
                                      :value="
                                        '總箱數：' + device_detail.box_qty
                                      "
                                      style="min-width: 135px"
                                    ></b-form-input>
                                  </b-input-group>
                                </div>
                                <div v-else>
                                  <b-input-group
                                    :prepend="
                                      sideBarSelect.process.name == '出貨' &&
                                      shipment_process == '裝櫃-即時狀態'
                                        ? '貨車資訊'
                                        : '機台狀態'
                                    "
                                    class="mb-2"
                                  >
                                    <b-form-input
                                      v-if="
                                        sideBarSelect.process.name != '包裝' &&
                                        sideBarSelect.process.name != '出貨'
                                      "
                                      aria-label="First name"
                                      disabled
                                      :value="
                                        '運轉時間：' +
                                        device_detail.device_run_time
                                      "
                                      style="min-width: 180px"
                                    ></b-form-input>
                                    <b-form-input
                                      v-if="
                                        sideBarSelect.process.name != '包裝' &&
                                        sideBarSelect.process.name != '出貨'
                                      "
                                      aria-label="First name"
                                      disabled
                                      :value="'待機時間：' + device_detail.device_queue_time"
                                      style="min-width: 180px"
                                    ></b-form-input>
                                    <b-form-input
                                      v-if="
                                        sideBarSelect.process.name != '包裝' &&
                                        sideBarSelect.process.name != '出貨'
                                      "
                                      aria-label="Last name"
                                      disabled
                                      :value="
                                        '開機稼動率：' +
                                        device_detail.device_activation +
                                        '%'
                                      "
                                      style="min-width: 165px"
                                    ></b-form-input>
                                    <b-form-input
                                      v-if="
                                        sideBarSelect.process.name != '包裝' &&
                                        sideBarSelect.process.name != '出貨'
                                      "
                                      aria-label="Last name"
                                      disabled
                                      :value="
                                        '日累計產量：' +
                                        Number(
                                          device_detail.device_day_count
                                        ).toLocaleString('en-US') +
                                        (device_detail.process != '熱處理'
                                          ? '(PCS)'
                                          : '(KG)')
                                      "
                                      style="min-width: 215px"
                                    ></b-form-input>
                                    <b-form-input
                                      v-if="
                                        device_detail.process != '熱處理' &&
                                        sideBarSelect.process.name != '包裝' &&
                                        sideBarSelect.process.name != '出貨'
                                      "
                                      aria-label="Last name"
                                      disabled
                                      :value="
                                        '標準RPM：' +
                                        device_detail.device_capacity_min
                                      "
                                      style="min-width: 135px"
                                    ></b-form-input>
                                    <b-form-input
                                      v-if="
                                        sideBarSelect.process.name == '包裝'
                                      "
                                      aria-label="Last name"
                                      disabled
                                      :value="
                                        '開始時間：' + device_detail.start_time
                                      "
                                      style="min-width: 135px"
                                    ></b-form-input>
                                    <b-form-input
                                      v-if="
                                        sideBarSelect.process.name == '包裝'
                                      "
                                      aria-label="Last name"
                                      disabled
                                      :value="
                                        '預計完工時間：' +
                                        device_detail.pre_time
                                      "
                                      style="min-width: 135px"
                                    ></b-form-input>
                                    <b-form-input
                                      v-if="
                                        sideBarSelect.process.name == '出貨' &&
                                        shipment_process == '裝櫃-即時狀態'
                                      "
                                      aria-label="Last name"
                                      disabled
                                      :value="
                                        '車牌號碼：' + device_detail.car_license
                                      "
                                      style="min-width: 135px"
                                    ></b-form-input>
                                  </b-input-group>
                                </div>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col
                            v-else
                            cols="12"
                            sm="12"
                            md="12"
                            lg="8"
                            xl="9"
                            class="p-0 m-0"
                          >
                            <b-row class="mx-0">
                              <b-col
                                cols="12"
                                class="p-0 mx-0"
                                style="margin-bottom: 2.3rem"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="4"
                                    sm="4"
                                    md="4"
                                    lg="4"
                                    xl="2"
                                    class="p-0 mb-1 text-left"
                                    style="line-height: 2rem"
                                  >
                                    <span class="m-0" style>製程:</span>
                                    <span class="m-0" style>-</span>
                                  </b-col>
                                  <b-col
                                    cols="4"
                                    sm="4"
                                    md="4"
                                    lg="4"
                                    xl="2"
                                    class="p-0 mb-1 text-left"
                                    style="line-height: 2rem"
                                  >
                                    <span class="m-0" style>產線:</span>
                                    <span class="m-0" style>-</span>
                                  </b-col>
                                  <b-col
                                    cols="4"
                                    sm="4"
                                    md="4"
                                    lg="4"
                                    xl="2"
                                    class="p-0 mb-1 text-left"
                                    style="line-height: 2rem"
                                  >
                                    <span class="m-0" style>機號:</span>
                                    <span class="m-0" style>-</span>
                                  </b-col>
                                  <b-col
                                    cols="4"
                                    sm="4"
                                    md="4"
                                    lg="4"
                                    xl="2"
                                    class="p-0 mb-1 text-left"
                                    style="line-height: 2rem"
                                  >
                                    <span class="m-0" style>型號:</span>
                                    <span class="m-0" style>-</span>
                                  </b-col>
                                  <b-col
                                    cols="12"
                                    sm="8"
                                    md="8"
                                    lg="8"
                                    xl="4"
                                    class="p-0 mb-1 text-right"
                                    style="line-height: 2rem"
                                  >
                                    <span class="m-0" style>狀態:</span>
                                    <span class="m-0" style>
                                      <div
                                        style="
                                          display: inline-block;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          padding: 0px 13px;
                                          width: 4.25rem;
                                          height: 2rem;
                                          line-height: 2rem;
                                          font-size: 1.125rem;
                                          font-family: dfyuanstd-w7,
                                            dfyuanstd-w5;
                                          text-align: center;
                                          margin: 0 0 0 0.5rem;
                                          font-weight: normal;
                                        "
                                      >
                                        運轉
                                      </div>
                                      <div
                                        style="
                                          display: inline-block;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          padding: 0px 13px;
                                          width: 4.25rem;
                                          height: 2rem;
                                          line-height: 2rem;
                                          font-size: 1.125rem;
                                          font-family: dfyuanstd-w7,
                                            dfyuanstd-w5;
                                          text-align: center;
                                          margin: 0 0 0 0.5rem;
                                          font-weight: normal;
                                        "
                                      >
                                        訊息
                                      </div>
                                      <div
                                        style="
                                          display: inline-block;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          padding: 0px 13px;
                                          width: 4.25rem;
                                          height: 2rem;
                                          line-height: 2rem;
                                          font-size: 1.125rem;
                                          font-family: dfyuanstd-w7,
                                            dfyuanstd-w5;
                                          text-align: center;
                                          margin: 0 0 0 0.5rem;
                                          font-weight: normal;
                                        "
                                      >
                                        異常
                                      </div>
                                    </span>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>

                            <b-row class="mx-0">
                              <b-col cols="12" class="p-0 m-0 mb-2">
                                <b-input-group prepend="機台狀態" class="mb-2">
                                  <b-form-input
                                    aria-label="First name"
                                    disabled
                                    value="運轉時間："
                                    style="min-width: 210px"
                                  ></b-form-input>
                                  <b-form-input
                                    aria-label="Last name"
                                    disabled
                                    value="開機稼動率："
                                    style="min-width: 165px"
                                  ></b-form-input>
                                  <b-form-input
                                    aria-label="Last name"
                                    disabled
                                    value="日累計產量："
                                    style="min-width: 215px"
                                  ></b-form-input>
                                  <b-form-input
                                    aria-label="Last name"
                                    disabled
                                    value="標準RPM："
                                    style="min-width: 135px"
                                  ></b-form-input>
                                </b-input-group>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>

                        <!-- <stackBar /> -->
                        <div v-if="sideBarSelect.process.name == '熱處理'">
                          <b-row>
                            <b-col cols="12">
                              <div
                                class="stackBarTitle"
                                style="padding-bottom: 25px"
                              >
                                焠火入料狀態 :
                              </div>
                              <div class="stackBarContent">
                                <b-row>
                                  <b-col cols="12">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="
                                        device_detail.ht_in_stack_information !=
                                        undefined
                                          ? device_detail.ht_in_stack_information
                                          : stacksBarDefault
                                      "
                                      :stacksSize="'normal'"
                                    />
                                  </b-col>
                                </b-row>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12">
                              <div class="stackBarTitle">出料狀態 :</div>
                              <div class="stackBarContent">
                                <b-row>
                                  <b-col cols="12">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="
                                        device_detail.ht_out_stack_information !=
                                        undefined
                                          ? device_detail.ht_out_stack_information
                                          : stacksBarDefault
                                      "
                                    />
                                  </b-col>
                                </b-row>
                              </div>
                            </b-col>
                          </b-row>
                        </div>
                        <div
                          v-else-if="sideBarSelect.process.name == '出貨'"
                        ></div>
                        <div
                          v-else-if="sideBarSelect.process.name == '包裝'"
                          class="mt-2"
                        >
                          <stackBar
                            :stacksBarClass="stacksBarClass"
                            :stacksBarMaxValue="43200"
                            :stacksData="
                              package_stack != undefined
                                ? package_stack
                                : stacksBarDefault
                            "
                            :stacksSize="'package-normal'"
                          />
                        </div>
                        <div v-else>
                          <stackBar
                            :stacksBarClass="stacksBarClass"
                            :stacksBarMaxValue="stacksBarMaxValue"
                            :stacksData="
                              device_detail.stack_bar_information != undefined
                                ? device_detail.stack_bar_information
                                : stacksBarDefault
                            "
                            :stacksSize="'normal'"
                          />
                        </div>

                        <!-- stacksBarDefault -->
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <b-row class="mx-0">
                  <b-col cols="12" class="pb-3 m-0 mt-3">
                    <b-tabs class="customize-tab" v-model="tabIndex">
                      <b-tab
                        :title="
                          sideBarSelect.process.name == '出貨' &&
                          shipment_process == '齊貨狀態'
                            ? '齊貨狀態'
                            : sideBarSelect.process.name == '出貨' &&
                              shipment_process == '裝櫃-即時狀態'
                            ? '裝櫃-即時狀態'
                            : '即時工單狀態'
                        "
                        lazy
                        class="mt-3"
                      >
                        <template v-if="sideBarSelect.process.name == '熱處理'">
                          <b-col cols="12" class="m-0 mt-3 text-left">
                            <template v-if="ht_work_code.length != 0">
                              <b-button
                                v-for="(item, key) in ht_work_code"
                                :key="key"
                                class="mr-2 mb-1"
                                :class="{
                                  ht_work_code_active: ht_button_select == key,
                                }"
                                @click="
                                  (ht_button_select = key),
                                    selectWorkCodeInfo(key)
                                "
                              >
                                工單{{ key + 1 }}
                                <!-- {{ item.work_code_information[0].work_code }} -->
                              </b-button>
                            </template>
                            <template v-else>
                              <b-button class="mr-2 mb-1">工單1 </b-button>
                            </template>
                          </b-col>
                          <workCodeInformation
                            class="text-left"
                            style="margin-top: 1.875rem"
                          />
                          <produceInformationHeat
                            class="text-left"
                            style="margin-top: 1.875rem; min-height: 80px"
                          />
                          <div class="mt-5">
                            <div
                              style="
                                padding: 0px 15px;
                                margin: 15px 0px;
                                width: 100%;
                                text-align: center;
                                white-space: nowrap;
                              "
                            >
                              <div
                                ref="ht_in_text"
                                style="
                                  display: inline-block;
                                  width: 5rem;
                                  vertical-align: middle;
                                "
                              >
                                輾牙重量:
                              </div>
                              <div
                                style="
                                  display: inline-block;
                                  width: calc(99% - 5rem);
                                  vertical-align: middle;
                                "
                                class="position-relative"
                              >
                                <div
                                  class="progress position-relative"
                                  style="height: 45px"
                                >
                                  <div
                                    v-if="percent_bar.work_code == ''"
                                    class="progress-bar"
                                    style="width: 0%; background-color: #000000"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.thd_percent != '' &&
                                      device_detail.machine_status == 'R'
                                    "
                                    class="progress-bar"
                                    style="background-color: #00b152"
                                    :style="{
                                      width:
                                        percent_bar.thd_percent * 0.87 + '%',
                                    }"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.thd_percent != '' &&
                                      device_detail.machine_status == 'Q'
                                    "
                                    class="progress-bar"
                                    style="background-color: #ffc100"
                                    :style="{
                                      width:
                                        percent_bar.thd_percent * 0.87 + '%',
                                    }"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.thd_percent != '' &&
                                      device_detail.machine_status == 'H'
                                    "
                                    class="progress-bar"
                                    style="background-color: #c10000"
                                    :style="{
                                      width:
                                        percent_bar.thd_percent * 0.87 + '%',
                                    }"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.thd_percent != '' &&
                                      device_detail.machine_status == 'M'
                                    "
                                    class="progress-bar"
                                    style="background-color: #cccdfe"
                                    :style="{
                                      width:
                                        percent_bar.thd_percent * 0.87 + '%',
                                    }"
                                  ></div>
                                  <span
                                    v-if="percent_bar.work_code == ''"
                                    class="elecboard-progress-bar-text mb-0"
                                  ></span>
                                  <span
                                    v-else-if="percent_bar.work_code != ''"
                                    class="
                                      elecboard-progress-bar-text
                                      mx-auto
                                      mb-0
                                    "
                                    style="
                                      line-height: 45px;
                                      font-size: 1.3rem;
                                      position: absolute;
                                      width: 100%;
                                    "
                                    >{{
                                      percent_bar.af_thd_weight.toLocaleString(
                                        "en-US"
                                      ) +
                                      "/" +
                                      percent_bar.work_dispatch_weight.toLocaleString(
                                        "en-US"
                                      ) +
                                      " " +
                                      percent_bar.thd_percent +
                                      "%"
                                    }}
                                  </span>
                                </div>
                                <div
                                  style="
                                    width: 100%;
                                    height: 45px;
                                    position: absolute;
                                    left: 0;
                                    top: 0;
                                  "
                                >
                                  <div
                                    style="
                                      z-index: 10;
                                      position: absolute;
                                      width: 2px;
                                      height: 115%;
                                      background-color: #c10000;
                                      left: calc(90% * 0.87 - 1px);
                                      top: -15%;
                                    "
                                  >
                                    <div
                                      style="
                                        z-index: 10;
                                        position: absolute;
                                        color: #c10000;
                                        width: 60px;
                                        left: calc(90% * 0.87 - 30px);
                                        top: calc(-10% - 22px);
                                        text-align: center;
                                      "
                                    >
                                      {{
                                        (
                                          percent_bar.work_dispatch_weight * 0.9
                                        ).toLocaleString("en-US", {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        })
                                      }}
                                    </div>
                                  </div>
                                  <div
                                    style="
                                      position: absolute;
                                      width: 2px;
                                      height: 115%;
                                      background-color: #474747;
                                      left: calc(100% * 0.87 - 1px);
                                      top: -15%;
                                    "
                                  >
                                    <div
                                      style="
                                        z-index: 10;
                                        position: absolute;
                                        color: #474747;
                                        width: 60px;
                                        left: calc(100% * 0.87 - 30px);
                                        top: calc(-10% - 22px);
                                        text-align: center;
                                      "
                                    >
                                      {{
                                        percent_bar.work_dispatch_weight.toLocaleString(
                                          "en-US",
                                          {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0,
                                          }
                                        )
                                      }}
                                    </div>
                                  </div>
                                  <div
                                    style="
                                      position: absolute;
                                      width: 2px;
                                      height: 115%;
                                      background-color: #c10000;
                                      left: calc(110% * 0.87 - 1px);
                                      top: -15%;
                                    "
                                  >
                                    <div
                                      style="
                                        z-index: 10;
                                        position: absolute;
                                        color: #c10000;
                                        width: 60px;
                                        left: calc(110% * 0.87 - 30px);
                                        top: calc(-10% - 22px);
                                        text-align: center;
                                      "
                                    >
                                      {{
                                        (
                                          percent_bar.work_dispatch_weight * 1.1
                                        ).toLocaleString("en-US", {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        })
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              style="
                                padding: 0px 15px;
                                margin: 15px 0px;
                                width: 100%;
                                text-align: center;
                                white-space: nowrap;
                              "
                            >
                              <div
                                style="
                                  display: inline-block;
                                  width: 5rem;
                                  vertical-align: middle;
                                "
                              >
                                入料進度:
                              </div>
                              <div
                                style="
                                  display: inline-block;
                                  width: calc(99% - 5rem);
                                  vertical-align: middle;
                                "
                                class="position-relative"
                              >
                                <div
                                  class="progress position-relative"
                                  style="height: 45px"
                                >
                                  <div
                                    v-if="percent_bar.work_code == ''"
                                    class="progress-bar"
                                    style="width: 0%; background-color: #000000"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.work_percent != '' &&
                                      device_detail.machine_status == 'R'
                                    "
                                    class="progress-bar"
                                    style="background-color: #00b152"
                                    :style="{
                                      width:
                                        percent_bar.work_percent * 0.87 + '%',
                                    }"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.work_percent != '' &&
                                      device_detail.machine_status == 'Q'
                                    "
                                    class="progress-bar"
                                    style="background-color: #ffc100"
                                    :style="{
                                      width:
                                        percent_bar.work_percent * 0.87 + '%',
                                    }"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.work_percent != '' &&
                                      device_detail.machine_status == 'H'
                                    "
                                    class="progress-bar"
                                    style="background-color: #c10000"
                                    :style="{
                                      width:
                                        percent_bar.work_percent * 0.87 + '%',
                                    }"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.thd_percent != '' &&
                                      device_detail.machine_status == 'M'
                                    "
                                    class="progress-bar"
                                    style="background-color: #cccdfe"
                                    :style="{
                                      width:
                                        percent_bar.work_percent * 0.87 + '%',
                                    }"
                                  ></div>
                                  <span
                                    v-if="percent_bar.work_code == ''"
                                    class="elecboard-progress-bar-text mb-0"
                                  ></span>
                                  <span
                                    v-else-if="percent_bar.work_code != ''"
                                    class="
                                      elecboard-progress-bar-text
                                      mx-auto
                                      mb-0
                                    "
                                    style="
                                      line-height: 45px;
                                      font-size: 1.3rem;
                                      position: absolute;
                                      width: 100%;
                                    "
                                    >{{
                                      percent_bar.device_count.toLocaleString(
                                        "en-US"
                                      ) +
                                      "/" +
                                      percent_bar.work_qty.toLocaleString(
                                        "en-US"
                                      ) +
                                      " "
                                    }}
                                    {{
                                      percent_bar.work_qty == "-"
                                        ? "100.00%"
                                        : (
                                            (percent_bar.device_count /
                                              percent_bar.work_qty) *
                                            100
                                          ).toFixed(2) + "%"
                                    }}
                                  </span>
                                </div>
                                <div
                                  style="
                                    width: 100%;
                                    height: 45px;
                                    position: absolute;
                                    left: 0;
                                    top: 0;
                                  "
                                >
                                  <div
                                    style="
                                      z-index: 10;
                                      position: absolute;
                                      width: 2px;
                                      height: 100%;
                                      background-color: #c10000;
                                      left: calc(90% * 0.87 - 1px);
                                    "
                                  ></div>
                                  <div
                                    style="
                                      position: absolute;
                                      width: 2px;
                                      height: 100%;
                                      background-color: #474747;
                                      left: calc(100% * 0.87 - 1px);
                                    "
                                  ></div>
                                  <div
                                    style="
                                      position: absolute;
                                      width: 2px;
                                      height: 100%;
                                      background-color: #c10000;
                                      left: calc(110% * 0.87 - 1px);
                                    "
                                  ></div>
                                </div>
                              </div>
                            </div>
                            <div
                              style="
                                padding: 0px 15px;
                                margin: 15px 0px;
                                width: 100%;
                                text-align: center;
                                white-space: nowrap;
                              "
                            >
                              <div
                                ref="ht_in_text"
                                style="
                                  display: inline-block;
                                  width: 5rem;
                                  vertical-align: middle;
                                "
                              >
                                出料進度:
                              </div>
                              <div
                                style="
                                  display: inline-block;
                                  width: calc(99% - 5rem);
                                  vertical-align: middle;
                                "
                                class="position-relative"
                              >
                                <div
                                  class="progress position-relative"
                                  style="height: 45px"
                                >
                                  <div
                                    v-if="percent_bar.work_code == ''"
                                    class="progress-bar"
                                    style="width: 0%; background-color: #000000"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.work_out_percent != '' &&
                                      device_detail.machine_status == 'R'
                                    "
                                    class="progress-bar"
                                    style="background-color: #00b152"
                                    :style="{
                                      width:
                                        percent_bar.work_out_percent * 0.87 +
                                        '%',
                                    }"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.work_out_percent != '' &&
                                      device_detail.machine_status == 'Q'
                                    "
                                    class="progress-bar"
                                    style="background-color: #ffc100"
                                    :style="{
                                      width:
                                        percent_bar.work_out_percent * 0.87 +
                                        '%',
                                    }"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.work_out_percent != '' &&
                                      device_detail.machine_status == 'H'
                                    "
                                    class="progress-bar"
                                    style="background-color: #c10000"
                                    :style="{
                                      width:
                                        percent_bar.work_out_percent * 0.87 +
                                        '%',
                                    }"
                                  ></div>
                                  <div
                                    v-else-if="
                                      percent_bar.work_code != '' &&
                                      percent_bar.thd_percent != '' &&
                                      device_detail.machine_status == 'M'
                                    "
                                    class="progress-bar"
                                    style="background-color: #cccdfe"
                                    :style="{
                                      width:
                                        percent_bar.work_out_percent * 0.87 + '%',
                                    }"
                                  ></div>
                                  <span
                                    v-if="percent_bar.work_code == ''"
                                    class="elecboard-progress-bar-text mb-0"
                                  ></span>
                                  <span
                                    v-else-if="percent_bar.work_code != ''"
                                    class="
                                      elecboard-progress-bar-text
                                      mx-auto
                                      mb-0
                                    "
                                    style="
                                      line-height: 45px;
                                      font-size: 1.3rem;
                                      position: absolute;
                                      width: 100%;
                                    "
                                    >{{
                                      percent_bar.device_out_count.toLocaleString(
                                        "en-US"
                                      ) +
                                      "/" +
                                      percent_bar.work_qty.toLocaleString(
                                        "en-US"
                                      ) +
                                      " "
                                    }}
                                    {{
                                      percent_bar.work_qty == "-"
                                        ? "100.00%"
                                        : (
                                            (percent_bar.device_out_count /
                                              percent_bar.work_qty) *
                                            100
                                          ).toFixed(2) + "%"
                                    }}
                                  </span>
                                </div>
                                <div
                                  style="
                                    width: 100%;
                                    height: 45px;
                                    position: absolute;
                                    left: 0;
                                    top: 0;
                                  "
                                >
                                  <div
                                    style="
                                      z-index: 10;
                                      position: absolute;
                                      width: 2px;
                                      height: 100%;
                                      background-color: #c10000;
                                      left: calc(90% * 0.87 - 1px);
                                    "
                                  ></div>
                                  <div
                                    style="
                                      position: absolute;
                                      width: 2px;
                                      height: 100%;
                                      background-color: #474747;
                                      left: calc(100% * 0.87 - 1px);
                                    "
                                  ></div>
                                  <div
                                    style="
                                      position: absolute;
                                      width: 2px;
                                      height: 100%;
                                      background-color: #c10000;
                                      left: calc(110% * 0.87 - 1px);
                                    "
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <bucketUseInformation
                            class="text-left"
                            style="margin-top: 1.875rem"
                          />
                          <totalProduceTime
                            class="text-left"
                            style="margin-top: 1.875rem"
                          />
                        </template>
                        <template
                          v-else-if="sideBarSelect.process.name == '包裝'"
                        >
                          <workCodeInformationPackage
                            class="text-left"
                            style="margin-top: 1.875rem"
                          />
                          <produceInformationPackage
                            class="text-left"
                            style="margin-top: 1.875rem; min-height: 80px"
                          />
                          <shipmentInformation
                            class="text-left"
                            style="margin-top: 1.875rem"
                          />
                          <packageInformation
                            class="text-left"
                            style="margin-top: 1.875rem"
                          />
                          <palletInformation
                            class="text-left"
                            style="margin-top: 1.875rem"
                          />
                        </template>
                        <template
                          v-else-if="sideBarSelect.process.name == '出貨'"
                        >
                          <template v-if="shipment_process == '裝櫃-即時狀態'">
                            <containerInformation
                              class="text-left"
                              style="margin-top: 1.875rem; min-height: 80px"
                            />
                            <containerTime
                              class="text-left"
                              style="margin-top: 1.875rem; min-height: 80px"
                            />
                            <containerDetail
                              class="text-left"
                              style="margin-top: 1.875rem; min-height: 80px"
                            />
                          </template>
                          <template v-else-if="shipment_process == '齊貨狀態'">
                            <containerShipment
                              class="text-left"
                              style="margin-top: 1.875rem; min-height: 80px"
                            />
                          </template>
                        </template>
                        <template v-else>
                          <workCodeInformation
                            class="text-left"
                            style="margin-top: 1.875rem"
                          />
                          <produceInformationHead
                            class="text-left"
                            v-if="sideBarSelect.process.name == '打頭'"
                            style="margin-top: 1.875rem; min-height: 80px"
                          />
                          <produceInformationThread
                            class="text-left"
                            v-if="sideBarSelect.process.name == '輾牙'"
                            style="margin-top: 1.875rem; min-height: 80px"
                          />
                          <div
                            class="progress position-relative"
                            style="height: 45px; margin: 0px 15px"
                          >
                            <div
                              v-if="percent_bar.work_code == ''"
                              class="progress-bar"
                              style="width: 0%; background-color: #000000"
                            ></div>
                            <div
                              v-else-if="
                                percent_bar.work_code != '' &&
                                percent_bar.work_percent != '' &&
                                device_detail.machine_status == 'R'
                              "
                              class="progress-bar"
                              style="background-color: #00b152"
                              :style="{
                                width: percent_bar.work_percent + '%',
                              }"
                            ></div>
                            <div
                              v-else-if="
                                percent_bar.work_code != '' &&
                                percent_bar.work_percent != '' &&
                                device_detail.machine_status == 'Q'
                              "
                              class="progress-bar"
                              style="background-color: #ffc100"
                              :style="{
                                width: percent_bar.work_percent + '%',
                              }"
                            ></div>
                            <div
                              v-else-if="
                                percent_bar.work_code != '' &&
                                percent_bar.work_percent != '' &&
                                device_detail.machine_status == 'H'
                              "
                              class="progress-bar"
                              style="background-color: #c10000"
                              :style="{
                                width: percent_bar.work_percent + '%',
                              }"
                            ></div>
                            <div
                              v-else-if="
                                percent_bar.work_code != '' &&
                                percent_bar.work_percent != '' &&
                                device_detail.machine_status == 'M'
                              "
                              class="progress-bar"
                              style="background-color: #cccdfe"
                              :style="{
                                width: percent_bar.work_percent + '%',
                              }"
                            ></div>
                            <div
                              v-else-if="
                                percent_bar.work_code != '' &&
                                percent_bar.work_percent != '' &&
                                device_detail.machine_status == 'D'
                              "
                              class="progress-bar"
                              style="background-color: #09b0ff"
                              :style="{
                                width: percent_bar.work_percent + '%',
                              }"
                            ></div>
                            <div
                              v-else-if="
                                percent_bar.work_code != '' &&
                                percent_bar.work_percent != '' &&
                                device_detail.machine_status == 'I'
                              "
                              class="progress-bar"
                              style="background-color: #99f98c"
                              :style="{
                                width: percent_bar.work_percent + '%',
                              }"
                            ></div>
                            <span
                              v-if="percent_bar.work_code == ''"
                              class="elecboard-progress-bar-text mb-0"
                            ></span>
                            <span
                              v-else-if="percent_bar.work_code != ''"
                              class="elecboard-progress-bar-text mx-auto mb-0"
                              style="
                                line-height: 45px;
                                font-size: 1.3rem;
                                position: absolute;
                                width: 100%;
                              "
                              >{{
                                Number(percent_bar.device_count).toLocaleString(
                                  "en-US"
                                ) +
                                "/" +
                                Number(percent_bar.work_qty).toLocaleString(
                                  "en-US"
                                ) +
                                " " +
                                percent_bar.work_percent +
                                "%"
                              }}
                            </span>
                          </div>
                          <wireUseInformation
                            class="text-left"
                            v-if="sideBarSelect.process.name == '打頭'"
                            style="margin-top: 1.875rem"
                          />
                          <moldUseInformation
                            class="text-left"
                            v-if="sideBarSelect.process.name == '打頭'"
                            style="margin-top: 1.875rem"
                          />
                          <threadUseInformation
                            class="text-left"
                            v-if="sideBarSelect.process.name == '輾牙'"
                            style="margin-top: 1.875rem"
                          />
                          <bucketUseInformation
                            class="text-left"
                            style="margin-top: 1.875rem"
                          />
                          <totalProduceTime
                            class="text-left"
                            style="margin-top: 1.875rem"
                          />
                          <inspectionUseInformation
                            class="text-left"
                            style="margin-top: 1.875rem"
                          />
                        </template>
                      </b-tab>
                      <b-tab
                        v-if="sideBarSelect.process.name == '打頭'"
                        lazy
                        title="工單餘量"
                        class="mt-3"
                      >
                        <b-row class="mx-0" style="margin-bottom: 0.6rem">
                          <b-col cols="12" class="text-left mx-0">
                            工單餘量
                          </b-col>
                          <b-col cols="12" class="text-left mx-0">
                            未{{ device_detail.process }}工單資訊
                          </b-col>
                          <b-col cols="12" class="mx-0">
                            <b-table
                              :items="remainWorkCodeItem"
                              :fields="remainWorkCodeFields"
                              :no-border-collapse="true"
                              class="
                                text-center
                                remainWorkCode-table-detail
                                table-responsive
                              "
                            >
                              <template #cell(workQty)="data">
                                {{ Number(data.value).toLocaleString("en-US") }}
                              </template>
                              <template #cell(workStandWeight)="data">
                                {{ Number(data.value).toLocaleString("en-US") }}
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                      </b-tab>
                      <b-tab
                        v-if="
                          sideBarSelect.process.name != '包裝' &&
                          sideBarSelect.process.name != '出貨'
                        "
                        lazy
                        title="機台影像"
                        class="mt-3"
                        @click="query_machineCamera()"
                      >
                        <machineCamera />
                      </b-tab>
                      <b-tab
                        v-if="
                          sideBarSelect.process.name != '包裝' &&
                          sideBarSelect.process.name != '出貨'
                        "
                        lazy
                        title="運轉日誌"
                        class="mt-3"
                        @click="exportCsvData('operatelog')"
                      >
                        <b-row class="mx-0" style="margin-bottom: 0.6rem">
                          <b-col cols="12" class="text-right mx-0">
                            <exportCsv />
                          </b-col>
                        </b-row>
                        <operateLogData class="text-left" />
                      </b-tab>
                      <b-tab
                        v-if="
                          sideBarSelect.process.name != '出貨' &&
                          sideBarSelect.process.name != '包裝'
                        "
                        title="當日完成工單"
                        class="mt-3"
                        lazy
                        @click="
                          clear_select_workorderHistory(),
                            set_selectTag({
                              deviceCode: false,
                              productCode: true,
                              workCode: true,
                            }),
                            queryWorkorderHistory()
                        "
                      >
                        <template v-if="!workorderHistory_row_click">
                          <template v-if="sideBarSelect.process.name == '包裝'">
                            <workorderHistoryPackageData class="text-left" />
                          </template>
                          <template v-else>
                            <workorderHistoryData class="text-left" />
                          </template>
                        </template>
                        <template v-else>
                          <b-row class="mx-0">
                            <b-col
                              cols="12"
                              class="my-2"
                              style="font-size: 20px; line-height: 24px"
                            >
                              <div class="machStatus-back-button">
                                <p @click="clear_rowClickData()">返回</p>
                              </div>
                            </b-col>

                            <b-col cols="12" class="my-2 machStatus-detail">
                              <b-row class="mx-0">
                                <b-col cols="12" class="text-left d-block">
                                  <workorderHistoryCodeInformation
                                    class="text-left mt-2"
                                  />
                                  <headingProduceInformation
                                    class="text-left"
                                  />

                                  <produceInformation class="text-left" />

                                  <workorderHistoryWireUseInformation
                                    class="text-left"
                                  />

                                  <moldUseInformation class="text-left" />

                                  <threadUseInformation class="text-left" />

                                  <totalProduceTime class="text-left" />

                                  <b-row class="mx-0" style="">
                                    <!-- <b-col cols="12" class="" style="">
                                      <b-row class="mx-0 text-center">
                                        <div
                                          style="
                                            width: 140px;
                                            margin-right: 0.5rem;
                                            border-bottom: 0.6rem #427ace solid;
                                            padding: 0.5rem 1rem 0 1rem;
                                            background-color: transparent;
                                            color: #427ace;
                                            font-size: 1rem;
                                            font-family: dfyuanstd-w5,
                                              dfyuanstd-w3;
                                            cursor: pointer;
                                          "
                                          @click="process_insp_select = 5"
                                        >
                                          打頭
                                        </div>
                                        <div
                                          style="
                                            width: 140px;
                                            margin-right: 0.5rem;
                                            border-bottom: 0.6rem #009245 solid;
                                            padding: 0.5rem 1rem 0 1rem;
                                            background-color: transparent;
                                            color: #009245;
                                            font-size: 1rem;
                                            font-family: dfyuanstd-w5,
                                              dfyuanstd-w3;
                                            cursor: pointer;
                                          "
                                          @click="process_insp_select = 6"
                                        >
                                          輾牙
                                        </div>
                                        <div
                                          style="
                                            width: 140px;
                                            margin-right: 0.5rem;
                                            border-bottom: 0.6rem #ff6b00 solid;
                                            padding: 0.5rem 1rem 0 1rem;
                                            background-color: transparent;
                                            color: #ff6b00;
                                            font-size: 1rem;
                                            font-family: dfyuanstd-w5,
                                              dfyuanstd-w3;
                                            cursor: pointer;
                                          "
                                          @click="process_insp_select = 7"
                                        >
                                          熱處理
                                        </div>
                                      </b-row>
                                    </b-col> -->
                                    <b-col
                                      cols="12"
                                      class=""
                                      style="margin-top: 1.5rem"
                                    >
                                      <inspectionUseInformation
                                        class="text-left px-0"
                                      />
                                    </b-col>

                                    <heatTreatmentWorkData />
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </template>
                      </b-tab>
                      <b-tab
                        v-if="
                          sideBarSelect.process.name != '包裝' &&
                          sideBarSelect.process.name != '出貨'
                        "
                        title="警報履歷"
                        class="mt-3"
                        @click="
                          set_alarmHistoryDataItem(alarmHistory_information),
                            exportCsvData('alarmhistory')
                        "
                        lazy
                      >
                        <b-row class="mx-0" style="margin-bottom: 0.6rem">
                          <b-col cols="12" class="text-right mx-0">
                            <exportCsv />
                          </b-col>
                        </b-row>
                        <alarmHistoryData class="text-left" />
                      </b-tab>
                      <b-tab
                        v-if="
                          sideBarSelect.process.name != '包裝' &&
                          sideBarSelect.process.name != '出貨'
                        "
                        lazy
                        title="機台指示燈號"
                        class="mt-3"
                      >
                        <b-row class="mx-0">
                          <b-col cols="12" class="text-left">
                            <b-row
                              class="justify-content-start"
                              style="padding: 15px"
                            >
                              <b-col
                                v-for="(item, key) in machineItem_select"
                                :key="key"
                                cols="2"
                                xl="2"
                                lg="3"
                                md="4"
                                sm="6"
                                class="mt-2 ml-0 justify-content-center"
                              >
                                <b-card
                                  no-body
                                  class="overflow-hidden border-dark"
                                  style="max-width: 250px"
                                >
                                  <b-row
                                    no-gutters
                                    class="align-items-center text-center"
                                  >
                                    <b-col md="5">
                                      <b-card-img
                                        v-if="item.color == 'red'"
                                        :src="redlight"
                                        class="rounded-0"
                                        style="max-width: 85px"
                                      ></b-card-img>
                                      <b-card-img
                                        v-else-if="item.color == 'orange'"
                                        :src="orangelight"
                                        class="rounded-0"
                                        style="max-width: 85px"
                                      ></b-card-img>
                                      <b-card-img
                                        v-else-if="item.color == 'green'"
                                        :src="greenlight"
                                        class="rounded-0"
                                        style="max-width: 85px"
                                      ></b-card-img>
                                      <b-card-img
                                        v-else-if="item.color == 'white'"
                                        :src="whitelight"
                                        class="rounded-0"
                                        style="max-width: 85px"
                                      ></b-card-img>
                                      <b-card-img
                                        v-else-if="item.color == 'gray'"
                                        :src="graylight"
                                        class="rounded-0"
                                        style="max-width: 85px"
                                      ></b-card-img>
                                    </b-col>
                                    <b-col md="7" class>
                                      <b-card-text>{{ item.name }}</b-card-text>
                                    </b-col>
                                  </b-row>
                                </b-card>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-tab>
                      <!-- <b-tab
                        v-if="
                          sideBarSelect.process.name != '包裝' &&
                          sideBarSelect.process.name != '出貨'
                        "
                        lazy
                        title="健康狀態"
                        class="mt-3"
                      >
                        <machineHealth class="text-left" />
                      </b-tab> -->
                    </b-tabs>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col cols="1"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import stackBar from "@/components/stackBar.vue";
import workCodeInformation from "@/components/workCodeInformation.vue";
import wireUseInformation from "@/components/wireUseInformation.vue";
import moldUseInformation from "@/components/moldUseInformation.vue";
import threadUseInformation from "@/components/threadUseInformation.vue";
import bucketUseInformation from "@/components/bucketUseInformation.vue";
import inspectionUseInformation from "@/components/inspectionUseInformation.vue";
import totalProduceTime from "@/components/totalProduceTime.vue";
import machineCamera from "@/components/machineCamera.vue";
import operateLogData from "@/components/operateLogData.vue";
import workorderHistoryData from "@/components/workorderHistoryData.vue";
import alarmHistoryData from "@/components/alarmHistoryData.vue";
import machineHealth from "@/components/machineHealth.vue";
import workorderHistoryCodeInformation from "@/components/workorderHistoryCodeInformation.vue";
import workorderHistoryWireUseInformation from "@/components/workorderHistoryWireUseInformation.vue";
import headingProduceInformation from "@/components/headingProduceInformation.vue";
import produceInformation from "@/components/produceInformation.vue";
import produceInformationHead from "@/components/produceInformationHead.vue";
import produceInformationThread from "@/components/produceInformationThread.vue";
import produceInformationHeat from "@/components/produceInformationHeat.vue";
import exportCsv from "@/components/exportCsv.vue";
import heatTreatmentWorkData from "@/components/heatTreatmentWorkData.vue";
import workCodeInformationPackage from "@/components/workCodeInformationPackage.vue";
import shipmentInformation from "@/components/shipmentInformation.vue";
import produceInformationPackage from "@/components/produceInformationPackage.vue";
import packageInformation from "@/components/packageInformation.vue";
import palletInformation from "@/components/palletInformation.vue";
import workorderHistoryPackageData from "@/components/workorderHistoryPackageData.vue";
import containerInformation from "@/components/containerInformation.vue";
import containerDetail from "@/components/containerDetail.vue";
import containerTime from "@/components/containerTime.vue";
import containerShipment from "@/components/containerShipment.vue";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "MachStatus",
  data() {
    return {
      machineData: [],
      whitelight: require("../assets/light-white.png"),
      graylight: require("../assets/light-gray.png"),
      greenlight: require("../assets/light-green.png"),
      redlight: require("../assets/light-red.png"),
      orangelight: require("../assets/light-orange.png"),
      CBF: require("../assets/CBF.jpg"),
      CPR: require("../assets/CPR.png"),
      "heat-treatment-model": require("../assets/heat-treatment-model.jpg"),
      package: require("../assets/package-img.png"),
      container: require("../assets/container-img.jpg"),
      machineItem: {
        // pwr_light: { value: 1, color: "green", name: "電源燈" },
        // in_lube: { value: 1, color: "green", name: "潤滑中" },
        // overload: { value: 1, color: "red", name: "過負載" },
        // fnt_sf_pin: { value: 1, color: "red", name: "前沖安全銷" },
        // sf_door: { value: 1, color: "red", name: "安全門未關" },
        // air_press_light: { value: 1, color: "green", name: "氣壓燈" },
        // end_lube_press: { value: 1, color: "red", name: "末端油壓不足" },
        // inv_abn: { value: 1, color: "red", name: "變頻器異常" },
        // bk_sf_pin: { value: 1, color: "red", name: "後通安全銷" },
        // lube_overflow: { value: 1, color: "red", name: "油面溢位" },
        // mtr_end: { value: 1, color: "red", name: "材料終了" },
        // finish_cnt: { value: 1, color: "red", name: "計數終了" },
        // len_short: { value: 1, color: "red", name: "短吋" },
        // tab_float: { value: 1, color: "red", name: "挾料台浮動" },
      },
      machineItem_select: {
        // pwr_light: { color: "white", name: "電源燈" },
        // in_lube: { color: "white", name: "潤滑中" },
        // overload: { color: "white", name: "過負載" },
        // fnt_sf_pin: { color: "white", name: "前沖安全銷" },
        // sf_door: { color: "white", name: "安全門未關" },
        // air_press_light: { color: "white", name: "氣壓燈" },
        // end_lube_press: { color: "white", name: "末端油壓不足" },
        // inv_abn: { color: "white", name: "變頻器異常" },
        // bk_sf_pin: { color: "white", name: "後通安全銷" },
        // lube_overflow: { color: "white", name: "油面溢位" },
        // mtr_end: { color: "white", name: "材料終了" },
        // finish_cnt: { color: "white", name: "計數終了" },
        // len_short: { color: "white", name: "短吋" },
        // tab_float: { color: "white", name: "挾料台浮動" },
      },
      focusPlaceButtonSelect: 2,
      focusCircleButtonSelect: 1,
      tabIndex: 0,
      ipcam_1: true,
      ipcam_2: false,
      first_load: false,
      nowtime: "--",

      this_device_name: "",
      process_id: "",
      group_id: "",
      device_detail: {},
      device_image: "#",
      work_order_detail: {
        actual_weight: "--",
        device_count: "--",
        material_total_weight: "--",
        material_weight: "--",
        product_chinese_name: "--",
        productCode: "--",
        standard_total_weight: "--",
        standard_weight: "--",
        wire_chinese_name: "--",
        wire_code: "--",
        wire_consumption: "--",
        wire_now_weight: "--",
        wire_start_weight: "--",
        workCode: "--",
        workOrgCode: "--",
        work_control_card: "--",
        work_qty: "--",
        work_status: "--",
      },
      WorkorderHistory_detail: {
        device_name: "--",
        workCode: "--",
        workOrgCode: "--",
        work_qty: 0,
        commodity_code: "--",
        actual_weight: 0,
        unit_weight: 0,
        standard_weight: 0,
        product_name: "",
        wire_commodity_code: "--",
        wire_product_name: "",
        material_weight: 0,
        wire_need_weight: 0,
        mould_code: "--",
        control_card: "--",
        total_expend: 0,
        loss_rate: 0,
        total_work_time: "--",
      },
      percent_bar: {
        work_code: "",
        device_count: 0,
        work_qty: 0,
        work_percent: 0,
        device_out_count: 0,
        work_out_percent: 0,
        thd_percent: 0,
        af_thd_weight: 0,
        work_dispatch_weight: 0,
      },
      workorderHistory_row_click: false,
      work_code_information_item: [],
      wire_information_item: [],
      mould_information_item: [],
      thread_information_item: [],
      bucket_information_item: [],
      inspection_information: [],
      total_produce_time_information_item: [],
      // process_insp_select: 0,
      total_inspection_data: {},
      remainWorkCodeItem: [],
      remainWorkCodeFields: [
        // {
        //   key: "code",
        //   label: "工單編號",
        //   sortable: false,
        //   class: "font-family-dfyuanstd-w5 table-col-hight",
        // },
        {
          key: "work_org_code",
          label: "工單編號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "productCode",
          label: "料號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "control_card",
          label: "管制卡號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "product_chinese_name",
          label: "料名",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "mouldCode",
          label: "模具編號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "workQty",
          label: "派工支數",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "workStandWeight",
          label: "標準重量",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
      ],
      alarmHistory_information: [],
      operatelog_information_item: [],
      alarmHistory_information_item: [],
      inspection_project_information: {},
      total_work_time: [],
      oil_fields: [
        {
          key: "name",
          label: "名稱",
          sortable: true,
        },
        {
          key: "value",
          label: "值",
          sortable: true,
        },
      ],
      oil_items: [
        {
          isActive: true,
          name: "主油管迴路(主滑台側)",
          value: "9.15",
        },
        {
          isActive: true,
          name: "主油管迴路(剪斷側)",
          value: "6",
        },
        {
          isActive: true,
          name: "油管末端(主滑台側)",
          value: "3",
        },
        {
          isActive: true,
          name: "油管末端(主滑台側)",
          value: "2",
        },
      ],
      csv_field_title: [],
      firstReader: true,
      machineHealthData: [
        {
          name: "油壓",
          table: {
            fields: [
              {
                key: "name",
                label: "名稱",
                // sortable: true,
              },
              {
                key: "value",
                label: "值",
                // sortable: true,
              },
            ],
            items: [
              {
                isActive: true,
                name: "主油管迴路(主滑台側)",
                value: "--",
              },
              {
                isActive: true,
                name: "主油管迴路(剪斷側)",
                value: "--",
              },
              {
                isActive: true,
                name: "油管末端(主滑台側)",
                value: "--",
              },
              {
                isActive: true,
                name: "油管末端(剪斷側)",
                value: "--",
              },
            ],
          },
        },
        {
          name: "流量",
          table: {
            fields: [
              {
                key: "name",
                label: "名稱",
                // sortable: true,
              },
              {
                key: "value",
                label: "值",
                // sortable: true,
              },
            ],
            items: [
              {
                isActive: true,
                name: "主滑台(操作側)",
                value: "--",
              },
              {
                isActive: true,
                name: "主滑台(剪斷側)",
                value: "--",
              },
              {
                isActive: true,
                name: "主曲軸襯銅(操作側)",
                value: "--",
              },
              {
                isActive: true,
                name: "主曲軸襯銅(剪斷側)",
                value: "--",
              },
            ],
          },
        },
        {
          name: "溫度",
          table: {
            fields: [
              {
                key: "name",
                label: "名稱",
                // sortable: true,
              },
              {
                key: "value",
                label: "值",
                // sortable: true,
              },
            ],
            items: [
              {
                isActive: true,
                name: "主曲軸襯銅(操作側)",
                value: "--",
              },
              {
                isActive: true,
                name: "主曲軸襯銅(剪斷側)",
                value: "--",
              },
              {
                isActive: true,
                name: "主滑台鋼板(操作側)",
                value: "--",
              },
              {
                isActive: true,
                name: "主滑台鋼板(剪斷側)",
                value: "--",
              },
            ],
          },
        },
        {
          name: "空壓",
          table: {
            fields: [
              {
                key: "name",
                label: "名稱",
                // sortable: true,
              },
              {
                key: "value",
                label: "值",
                // sortable: true,
              },
            ],
            items: [
              {
                isActive: true,
                name: "三點組合",
                value: "--",
              },
            ],
          },
        },
        {
          name: "位置感測",
          table: {
            fields: [
              {
                key: "name",
                label: "名稱",
                // sortable: true,
              },
              {
                key: "value",
                label: "值",
                // sortable: true,
              },
            ],
            items: [
              {
                isActive: true,
                name: "主滑台上方",
                value: "--",
              },
            ],
          },
        },
        {
          name: "油溫",
          table: {
            fields: [
              {
                key: "name",
                label: "名稱",
                // sortable: true,
              },
              {
                key: "value",
                label: "值",
                // sortable: true,
              },
            ],
            items: [
              {
                isActive: true,
                name: "副油箱",
                value: "--",
              },
            ],
          },
        },
      ],
      machStatusAxios: null,
      machStatusAxiosSource: null,
      main_query_check: false,
      operateLogDataFields: [
        {
          key: "status",
          label: "狀態",
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "alarmCode",
          label: "代碼",
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "alarmDetail",
          label: "代碼說明",
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "startTime",
          label: "開始時間",
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "endTime",
          label: "結束時間",
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "durationTime",
          label: "持續時間",
          class: "font-family-dfyuanstd-w5",
        },
      ],
      alarmHistoryDataFields: [
        {
          key: "alarmCode",
          label: "警報代碼",
        },
        {
          key: "alarmDetail",
          label: "警報代碼說明",
        },
        {
          key: "alarmVideo",
          label: "機台影像",
        },
        {
          key: "startTime",
          label: "開始時間",
        },
        {
          key: "endTime",
          label: "結束時間",
        },
        {
          key: "continuousTime",
          label: "持續時間",
        },
      ],
      workorderHistoryDataFields: [
        // {
        //   key: "workID",
        //   label: "工單單號",
        // },
        {
          key: "work_org_code",
          label: "工單單號",
        },
        {
          key: "itemName",
          label: "產品品名",
        },
        {
          key: "qty",
          label: "派工數量(PCS)",
        },
        {
          key: "completeQty",
          label: "完工數量(PCS)",
        },
        {
          key: "weight",
          label: "派工重量(KG)",
        },
        {
          key: "completeWeight",
          label: "完工重量(KG)",
        },
        {
          key: "startTime",
          label: "開始時間",
        },
        {
          key: "endTime",
          label: "完成時間",
        },
      ],
      ht_work_code: [],
      ht_work_current_view: 0,
      ht_button_select: 0,
      timer_selectDevice: "",
      stacksBarDefault: {
        default: [
          {
            status: null,
            endTime: "2021-04-08 08:00:29",
            alarmDetail: "",
            startTime: "2021-04-08 08:00:00",
            duration_number: 0,
          },
        ],
      },
      query_counter: 0,
      previousPageName: "",
      this_shipment_name: "",
      package_stack: [],
    };
  },
  created: function () {
    window.addEventListener("beforeunload", this.setSessionItems);
    this.process_id = sessionStorage.getItem("mes_elecboard_process_id");
    this.group_id = sessionStorage.getItem("mes_elecboard_group_id");
    this.this_device_name = sessionStorage.getItem(
      "mes_machStatus_this_device_name"
    );
    if (this.this_device_name == undefined) {
      this.this_device_name = "";
    }
    this.tabIndex = sessionStorage.getItem("mes_machStatus_tabIndex");
    this.previousPageName = sessionStorage.getItem(
      "mes_machStatus_previousPageName"
    );
    if (this.previousPageName == "home") {
      this.set_previousPage("home");
    }
    if (this.process_id != undefined && this.group_id != undefined) {
      this.set_sideBarSelect(["elecboard", this.process_id, this.group_id]);
    }
    this.this_shipment_name = sessionStorage.getItem(
      "mes_machStatus_shipmentProcess"
    );
    if (this.this_shipment_name != undefined) {
      this.set_shipmentProcess(this.this_shipment_name);
    }
    this.change_selectPage("machstatus");
    this.change_selectPageName(this.pageName.machstatus);
    this.machStatusImportAxios();
    this.machStatusAxiosCancel();
    this.get_select_deviceName();
    this.set_operateLogDataFields(this.operateLogDataFields);
    this.set_operateLogTableStyle("machStatus-components-table");
    this.set_alarmHistoryDataFields(this.alarmHistoryDataFields);
    this.set_alarmHistoryTableStyle("machStatus-components-table");
    this.set_workorderHistoryDataFields(this.workorderHistoryDataFields);
    this.set_workorderHistoryTableStyle(
      "machStatus-components-table-workorderHistory"
    );
    this.set_deviceName(this.this_device_name);

    sessionStorage.removeItem("mes_elecboard_process_id");
    sessionStorage.removeItem("mes_elecboard_group_id");
    sessionStorage.removeItem("mes_machStatus_this_device_name");
    sessionStorage.removeItem("mes_machStatus_tabIndex");
    sessionStorage.removeItem("mes_machStatus_previousPageName");
    sessionStorage.removeItem("mes_machStatus_shipmentProcess");
  },
  mounted: function () {
    let vm = this;
    vm.resetExportCsv();
    vm.setExportDataTitle();
    vm.firstReader = false;
    vm.set_machineHealthData(this.machineHealthData);
    if (vm.tabIndex == 2) {
      vm.query_machineCamera();
    }
    if (vm.sideBarSelect.process.name == "包裝") {
      if (vm.tabIndex == 1) {
        vm.clear_select_workorderHistory();
        vm.set_selectTag({
          deviceCode: false,
          productCode: true,
          workCode: true,
        });
        vm.queryWorkorderHistory();
      }
    } else if (vm.sideBarSelect.process.name == "打頭") {
      if (vm.tabIndex == 4) {
        vm.clear_select_workorderHistory();
        vm.set_selectTag({
          deviceCode: false,
          productCode: true,
          workCode: true,
        });
        vm.queryWorkorderHistory();
      }
    } else {
      if (vm.tabIndex == 3) {
        vm.clear_select_workorderHistory();
        vm.set_selectTag({
          deviceCode: false,
          productCode: true,
          workCode: true,
        });
        vm.queryWorkorderHistory();
      }
    }
    // vm.getNowTime();
  },
  components: {
    stackBar,
    workCodeInformation,
    wireUseInformation,
    moldUseInformation,
    threadUseInformation,
    bucketUseInformation,
    inspectionUseInformation,
    totalProduceTime,
    machineCamera,
    operateLogData,
    workorderHistoryData,
    alarmHistoryData,
    machineHealth,
    workorderHistoryCodeInformation,
    workorderHistoryWireUseInformation,
    headingProduceInformation,
    produceInformation,
    produceInformationHead,
    produceInformationHeat,
    produceInformationThread,
    exportCsv,
    heatTreatmentWorkData,
    workCodeInformationPackage,
    shipmentInformation,
    produceInformationPackage,
    packageInformation,
    palletInformation,
    workorderHistoryPackageData,
    containerInformation,
    containerDetail,
    containerTime,
    containerShipment,
  },
  watch: {
    tabIndex: {
      handler() {
        let vm = this;
        vm.clear_rowClickData();
      },
    },
    rowClickData: {
      handler() {
        let vm = this;
        let row_data_array = Object.keys(vm.rowClickData);

        if (row_data_array.length == 0) {
          vm.workorderHistory_row_click = false;
          vm.set_wireUseInformationItem(vm.wire_information);
          vm.set_moldUseInformationItem(vm.mould_information);
          vm.set_threadUseInformationItem(vm.thread_information);
          vm.set_bucketUseInformationItem(vm.bucket_information);
          vm.set_inspectionUseSingleProcess(true);
          vm.set_inspectionUseInformationData(vm.inspection_information);
          vm.set_totalProduceTimeItem(vm.total_produce_time_information);
        } else {
          console.log(vm.rowClickData);
          vm.workorderHistory_row_click = true;
          vm.set_workorderHistoryCodeInformationItem([]);
          vm.set_workorderHistoryWireUseInformationItem([]);
          vm.set_headingProduceInformationItem([]);
          vm.set_produceInformationItem([]);
          vm.set_moldUseInformationItem([]);
          vm.set_threadUseInformationItem([]);
          vm.set_totalProduceTimeItem([]);
          vm.set_inspectionUseSingleProcess(false);
          vm.set_inspectionUseInformationData({});
          vm.set_htWorkDataItem([]);
          vm.show_loadScreenModal();
          vm.queryWorkIdFunction(vm.rowClickData.items.workID);
        }
      },
    },
    query_counter: {
      handler() {
        let vm = this;
        if (vm.query_counter >= 1500) {
          window.location.reload();
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      pageName: "getlogin/get_pageName",
      sideBarSelect: "sideBarTree/get_sideBarSelect",
      mainQueryResponse: "commonqueryiot/get_queryResponse",
      rowClickData: "workorderHistoryData/get_rowClickData",
      stacksBarClass: "stackBar/get_stacksBarClass",
      stacksBarMaxValue: "stackBar/get_stacksBarMaxValue",
      previousPage: "previousPage/get_previousPage",
      device_name: "selectDevice/get_deviceName",
      shipment_process: "selectDevice/get_shipmentProcess",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_sideBarSelect: "sideBarTree/set_sideBarSelect",
      set_otherData: "commonqueryiot/set_otherData",
      set_selectTag: "commonqueryiot/set_selectTag",
      set_previousPage: "previousPage/set_previousPage",
      clear_previousPage: "previousPage/clear_previousPage",
      set_shipmentProcess: "selectDevice/set_shipmentProcess",
      clear_shipmentProcess: "selectDevice/clear_shipmentProcess",
      set_workCodeInformationItem:
        "workCodeInformation/set_workCodeInformationItem",
      clear_workCodeInformationItem:
        "workCodeInformation/clear_workCodeInformationItem",
      set_wireUseInformationItem:
        "wireUseInformation/set_wireUseInformationItem",
      clear_wireUseInformationItem:
        "wireUseInformation/clear_wireUseInformationItem",
      set_moldUseInformationItem:
        "moldUseInformation/set_moldUseInformationItem",
      clear_moldUseInformationItem:
        "moldUseInformation/clear_moldUseInformationItem",
      set_threadUseInformationItem:
        "threadUseInformation/set_threadUseInformationItem",
      clear_threadUseInformationItem:
        "threadUseInformation/clear_threadUseInformationItem",
      set_bucketUseInformationItem:
        "bucketUseInformation/set_bucketUseInformationItem",
      clear_bucketUseInformation:
        "bucketUseInformation/clear_bucketUseInformation",
      set_inspectionUseInformationData:
        "inspectionUseInformation/set_inspectionUseInformationData",
      set_inspectionUseSingleProcess:
        "inspectionUseInformation/set_inspectionUseSingleProcess",
      clear_inspectionUseInformation:
        "inspectionUseInformation/clear_inspectionUseInformation",
      set_totalProduceTimeItem: "totalProduceTime/set_totalProduceTimeItem",
      set_machineCameraData: "machineCamera/set_machineCameraData",
      set_operateLogDataFields: "operateLogData/set_operateLogDataFields",
      set_operateLogTableStyle: "operateLogData/set_operateLogTableStyle",
      set_operateLogDataItem: "operateLogData/set_operateLogDataItem",
      clear_operateLogDataItem: "operateLogData/clear_operateLogDataItem",
      set_workorderHistoryDataItem:
        "workorderHistoryData/set_workorderHistoryDataItem",
      set_workorderHistoryDataFields:
        "workorderHistoryData/set_workorderHistoryDataFields",
      set_workorderHistoryTableStyle:
        "workorderHistoryData/set_workorderHistoryTableStyle",
      clear_workorderHistoryDataItem:
        "workorderHistoryData/clear_workorderHistoryDataItem",
      clear_rowClickData: "workorderHistoryData/clear_rowClickData",
      set_alarmHistoryDataItem: "alarmHistoryData/set_alarmHistoryDataItem",
      clear_alarmHistoryDataItem: "alarmHistoryData/clear_alarmHistoryDataItem",
      set_deviceName: "alarmHistoryData/set_deviceName",
      set_alarmHistoryDataFields: "alarmHistoryData/set_alarmHistoryDataFields",
      set_alarmHistoryTableStyle: "alarmHistoryData/set_alarmHistoryTableStyle",
      set_machineHealthData: "machineHealth/set_machineHealthData",
      clear_machineHealthData: "machineHealth/clear_machineHealthData",
      set_workorderHistoryCodeInformationItem:
        "workorderHistoryCodeInformation/set_workorderHistoryCodeInformationItem",
      set_workorderHistoryWireUseInformationItem:
        "workorderHistoryWireUseInformation/set_workorderHistoryWireUseInformationItem",
      set_headingProduceInformationItem:
        "headingProduceInformation/set_headingProduceInformationItem",
      set_produceInformationItem:
        "produceInformation/set_produceInformationItem",
      set_produceInformationHeadItem:
        "produceInformationHead/set_produceInformationHeadItem",
      set_produceInformationThreadItem:
        "produceInformationThread/set_produceInformationThreadItem",
      set_produceInformationHeatItem:
        "produceInformationHeat/set_produceInformationHeatItem",
      show_loadScreenModal: "loadscreenmodal/show_loadScreenModal",
      hide_loadScreenModal: "loadscreenmodal/hide_loadScreenModal",
      set_exportData: "exportcsv/set_exportData",
      set_exportDataTitle: "exportcsv/set_exportDataTitle",
      set_exportFileName: "exportcsv/set_exportFileName",
      set_htWorkDataItem: "htWorkData/set_htWorkDataItem",
      set_produceInformationPackageItem:
        "produceInformationPackage/set_produceInformationPackageItem",
      clear_produceInformationPackageItem:
        "produceInformationPackage/clear_produceInformationPackageItem",
      set_workCodeInformationPackageItem:
        "workCodeInformationPackage/set_workCodeInformationPackageItem",
      clear_workCodeInformationPackageItem:
        "workCodeInformationPackage/clear_workCodeInformationPackageItem",
      set_shipmentInformationItem:
        "shipmentInformation/set_shipmentInformationItem",
      clear_shipmentInformationItem:
        "shipmentInformation/clear_shipmentInformationItem",
      set_packageInformationItem:
        "packageInformation/set_packageInformationItem",
      clear_packageInformationItem:
        "packageInformation/clear_packageInformationItem",
      set_palletInformationItem: "palletInformation/set_palletInformationItem",
      clear_palletInformationItem:
        "palletInformation/clear_palletInformationItem",
      set_workorderHistoryPackageDataItem:
        "workorderHistoryPackageData/set_workorderHistoryPackageDataItem",
      clear_workorderHistoryPackageDataItem:
        "workorderHistoryPackageData/clear_workorderHistoryPackageDataItem",
      set_containerDetailItem: "containerDetail/set_containerDetailItem",
      clear_containerDetailItem: "containerDetail/clear_containerDetailItem",
      set_containerInformationItem:
        "containerInformation/set_containerInformationItem",
      clear_containerInformationItem:
        "containerInformation/clear_containerInformationItem",
      set_containerTimeItem: "containerTime/set_containerTimeItem",
      clear_containerTimeItem: "containerTime/clear_containerTimeItem",
      set_containerShipmentItem: "containerShipment/set_containerShipmentItem",
      clear_containerShipmentItem:
        "containerShipment/clear_containerShipmentItem",
    }),
    get_select_deviceName() {
      let vm = this;
      let device_name = vm.device_name;
      console.log(device_name);
      vm.process_id = vm.sideBarSelect.process.id;
      vm.group_id = vm.sideBarSelect.group.id;
      console.log(vm.this_device_name);
      if (device_name == "" && vm.this_device_name == "") {
        vm.change_selectPage("elecboard");
        vm.change_selectPageName(vm.pageName.elecboard);
        vm.clearTimer();
        vm.$router.push("/index/elecboard");
      } else if (vm.this_device_name != "") {
        vm.selectDevice(vm.this_device_name);
        vm.set_otherData(vm.this_device_name);
      } else if (device_name != "") {
        vm.selectDevice(device_name);
        vm.set_otherData(device_name);
        vm.this_device_name = device_name;
      }
    },
    selectDevice(device) {
      let vm = this;
      if (vm.selectPage != "machstatus") {
        return;
      }
      vm.clearTimer(vm.timer_selectDevice);
      if (!vm.first_load) {
        vm.show_loadScreenModal();
      }
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "GET";
      params["whichFunction"] = "SelectMachineQuery";
      params["device_name"] = device;
      params["group"] = vm.sideBarSelect.group.name;
      params["process"] = vm.sideBarSelect.process.name;
      if (vm.sideBarSelect.process.name == "出貨") {
        params["shipment_process"] = vm.shipment_process;
      }
      vm.machStatusAxiosAction(params, "selectDevice");
    },
    queryWorkorderHistory() {
      let vm = this;
      let endTime = new Date();
      let startTime = new Date(endTime.getTime() - 172800000);
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["whichFunction"] = "WorkorderHistory";
      params["startTime"] = `${startTime.getFullYear()}-${
        startTime.getMonth() + 1
      }-${startTime.getDate()} ${startTime.getHours()}:${startTime.getMinutes()}:${startTime.getSeconds()}`;
      params["endTime"] = `${endTime.getFullYear()}-${
        endTime.getMonth() + 1
      }-${endTime.getDate()} ${endTime.getHours()}:${endTime.getMinutes()}:${endTime.getSeconds()}`;
      if (vm.this_device_name != "") {
        params["deviceID"] = vm.this_device_name;
      } else if (device_name != "") {
        params["deviceID"] = vm.device_name;
      }
      params["process"] = vm.sideBarSelect.process.name;
      params["group"] = vm.sideBarSelect.group.name
      console.log(params);
      vm.show_loadScreenModal();
      vm.axiosAction(params).then(() => {
        vm.hide_loadScreenModal();
        var result = vm.axiosResult;
        console.log(result);
        if (result["Response"] == "ok") {
          let result_Data = result["QueryTableData"];

          let workorderHistoryArray = [];
          if (vm.sideBarSelect.process.name == "包裝") {
            for (let i = 0; i < result_Data.length; i++) {
              let workorderHistoryObj = {};
              workorderHistoryObj["work_code"] = result_Data[i]["work_code"];
              workorderHistoryObj["product_code"] =
                result_Data[i]["product_code"];
              workorderHistoryObj["product_name"] =
                result_Data[i]["product_name"];
              workorderHistoryObj["runcard_code"] =
                result_Data[i]["runcard_code"];
              workorderHistoryObj["box_qty"] = result_Data[i]["box_qty"];
              workorderHistoryObj["start_time"] = result_Data[i]["start_time"];
              workorderHistoryObj["end_time"] = result_Data[i]["end_time"];
              workorderHistoryArray.push(workorderHistoryObj);
            }
            console.log(workorderHistoryArray);
            vm.set_workorderHistoryPackageDataItem(workorderHistoryArray);
          } else {
            for (let i = 0; i < result_Data.length; i++) {
              let workorderHistoryObj = {};
              workorderHistoryObj["workID"] = result_Data[i]["workID"];
              workorderHistoryObj["work_org_code"] =
                result_Data[i]["work_org_code"];
              workorderHistoryObj["itemName"] = result_Data[i]["itemName"];
              workorderHistoryObj["qty"] = result_Data[i]["qty"];
              workorderHistoryObj["completeQty"] =
                result_Data[i]["completeQty"];
              workorderHistoryObj["weight"] = result_Data[i]["weight"];
              workorderHistoryObj["completeWeight"] =
                result_Data[i]["completeWeight"];
              workorderHistoryObj["startTime"] = result_Data[i]["startTime"];
              workorderHistoryObj["endTime"] = result_Data[i]["endTime"];
              workorderHistoryArray.push(workorderHistoryObj);
            }
            console.log(workorderHistoryArray);
            vm.set_workorderHistoryDataItem(workorderHistoryArray);
          }
          vm.set_exportData(workorderHistoryArray);
        } else if (result["Response"] == "no data") {
          vm.set_alertMsg("查無資料");
          vm.settimeout_alertModal();
          vm.set_workorderHistoryDataItem([]);
          vm.set_exportData([]);
        } else {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
          vm.set_workorderHistoryDataItem([]);
          vm.set_exportData([]);
        }
      });
    },
    getNowTime() {
      let vm = this;
      let Today = new Date();
      vm.nowtime =
        Today.getFullYear() +
        "-" +
        String(Today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(Today.getDate()).padStart(2, "0") +
        " " +
        String(Today.getHours()).padStart(2, "0") +
        ":" +
        String(Today.getMinutes()).padStart(2, "0") +
        ":" +
        String(Today.getSeconds()).padStart(2, "0");
      // setTimeout(function () {
      //   vm.getNowTime();
      // }, 1000);
    },
    query_machineCamera() {
      let vm = this;
      let device_name = vm.device_name;
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["group"] = vm.sideBarSelect.group.name;
      params["methods"] = "POST";
      params["whichFunction"] = "QueryMachineCamera";
      if (vm.this_device_name != "") {
        params["device_name"] = vm.this_device_name;
      } else {
        params["device_name"] = device_name;
      }
      console.log(params);
      vm.axiosAction(params).then(() => {
        var result = vm.axiosResult;
        console.log(result);
        if (result["Response"] == "ok") {
          vm.set_machineCameraData(result["QueryTableData"]);
        } else {
          vm.set_machineCameraData([]);
          console.log("erro MachineCamera" + result["QueryTableData"]);
        }
      });
    },
    queryWorkIdFunction(workID) {
      let vm = this;
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["whichFunction"] = "QueryWorkId";
      params["workID"] = workID;
      params["process"] = vm.process_id;
      console.log(params);
      vm.axiosAction(params).then(() => {
        vm.hide_loadScreenModal();
        var result = vm.axiosResult;
        console.log(result);
        // vm.change_tableBusy();
        if (result["Response"] == "ok") {
          let result_Data = result["QueryTableData"][0];

          let work_code_information_response =
            result_Data["work_code_information"];
          let work_code_information_item = [];
          if (work_code_information_response.length > 0) {
            work_code_information_response.forEach((data) => {
              let work_code_information_obj = {};
              // work_code_information_obj["code"] = {
              //   code: data["code"],
              //   org_code: data["org_code"],
              // };
              work_code_information_obj["work_org_code"] =
                data["work_org_code"];
              work_code_information_obj["productCode"] = data["productCode"];
              work_code_information_obj["control_card"] = data["control_card"];
              work_code_information_obj["product_chinese_name"] =
                data["product_chinese_name"];
              work_code_information_obj["mould_code"] = data["mould_code"];
              work_code_information_obj["work_qty"] = data["work_qty"];
              work_code_information_obj["standard_total_weight"] =
                data["standard_total_weight"];

              work_code_information_item.push(work_code_information_obj);
            });
          }
          vm.set_workorderHistoryCodeInformationItem(
            work_code_information_item
          );

          let wire_information_response = result_Data["wire_information"];
          let wire_information_item = [];
          if (wire_information_response.length > 0) {
            wire_information_response.forEach((data) => {
              let wire_information_obj = {};
              wire_information_obj["code"] = data["code"];
              wire_information_obj["chinese_name"] = data["chinese_name"];
              wire_information_obj["scroll_no"] = data["scroll_no"];
              wire_information_obj["furnaceCode"] = data["furnaceCode"];
              wire_information_obj["start_weight"] = data["start_weight"];
              wire_information_obj["remain_weight"] = data["remain_weight"];
              wire_information_obj["consumption"] = data["consumption"];
              // wire_information_obj["attrition"] = data["attrition"];
              wire_information_item.push(wire_information_obj);
            });
          }
          vm.set_workorderHistoryWireUseInformationItem(wire_information_item);

          let heading_produce_information_response =
            result_Data["heading_produce_information"];
          let heading_produce_information_item = [];
          if (heading_produce_information_response.length > 0) {
            heading_produce_information_response.forEach((data) => {
              let heading_produce_information_obj = {};
              heading_produce_information_obj["item_title"] =
                data["item_title"];
              heading_produce_information_obj["unit_weight"] =
                data["unit_weight"];
              heading_produce_information_obj["standard_total_weight"] =
                data["standard_total_weight"];
              heading_produce_information_obj["material_total_weight"] =
                data["material_total_weight"];
              heading_produce_information_item.push(
                heading_produce_information_obj
              );
            });
          }
          vm.set_headingProduceInformationItem(
            heading_produce_information_item
          );

          let produce_information_response = result_Data["produce_information"];
          let produce_information_item = [];
          if (produce_information_response.length > 0) {
            produce_information_response.forEach((data) => {
              let produce_information_obj = {};
              produce_information_obj["process"] = data["process"];
              produce_information_obj["pre_total_weight"] =
                data["pre_total_weight"];
              produce_information_obj["total_weight"] = data["total_weight"];
              produce_information_obj["attrition_rate_act"] =
                data["attrition_rate_act"];
              produce_information_obj["attrition_rate_standard"] =
                data["attrition_rate_standard"];
              produce_information_obj["rework"] = data["rework"];
              if (data.hasOwnProperty("ht_in_process")) {
                produce_information_obj["ht_in_process"] =
                  data["ht_in_process"];
              } else {
                produce_information_obj["ht_in_process"] = "-";
              }
              produce_information_item.push(produce_information_obj);
            });
          }
          vm.set_produceInformationItem(produce_information_item);

          let use_mould_response = result_Data["use_mould"];
          let use_mould_item = [];
          if (use_mould_response.length > 0) {
            use_mould_response.forEach((data) => {
              let use_mould_obj = {};
              use_mould_obj["code"] = data["code"];
              use_mould_obj["seriesNo"] = data["seriesNo"];
              use_mould_obj["name"] = data["name"];
              use_mould_obj["used_life"] = data["used_life"];
              use_mould_obj["standard_life"] = data["standard_life"];
              use_mould_item.push(use_mould_obj);
            });
          }
          vm.set_moldUseInformationItem(use_mould_item);

          let use_thread_response = result_Data["use_thread"];
          let use_thread_item = [];
          if (use_thread_response.length > 0) {
            use_thread_response.forEach((data) => {
              let use_thread_obj = {};
              use_thread_obj["code"] = data["code"];
              use_thread_obj["seriesNo"] = data["seriesNo"];
              use_thread_obj["name"] = data["name"];
              use_thread_obj["used_life"] = data["used_life"];
              use_thread_obj["standard_life"] = data["standard_life"];
              use_thread_item.push(use_thread_obj);
            });
          }
          vm.set_threadUseInformationItem(use_thread_item);

          let total_work_time_response = result_Data["total_work_time"];
          let total_work_time_item = [];
          if (total_work_time_response.length > 0) {
            total_work_time_response.forEach((data) => {
              let total_work_time_obj = {};
              total_work_time_obj["code"] = data["code"];
              total_work_time_obj["device_name"] = data["device_name"];
              total_work_time_obj["startTime"] = data["startTime"];
              total_work_time_obj["endTime"] = data["endTime"];
              total_work_time_obj["totalTime"] = data["total_time"];
              if (data.hasOwnProperty("rework")) {
                total_work_time_obj["rework"] = data["rework"];
              } else {
                total_work_time_obj["rework"] = false;
              }
              if (data.hasOwnProperty("ht_in_process")) {
                total_work_time_obj["ht_in_process"] = data["ht_in_process"];
              } else {
                total_work_time_obj["ht_in_process"] = false;
              }
              total_work_time_item.push(total_work_time_obj);
            });
          }
          vm.set_totalProduceTimeItem(total_work_time_item);

          let total_inspection_data_response =
            result_Data["total_inspection_data"];
          vm.set_inspectionUseInformationData(total_inspection_data_response);
          // let total_inspection_process = Object.keys(
          //   total_inspection_data_response
          // );

          // if (total_inspection_process.length > 0) {
          //   vm.total_inspection_data = total_inspection_data_response;
          //   let process_insp_select = total_inspection_process[0];
          //   vm.process_insp_select = process_insp_select;
          // } else {
          //   vm.total_inspection_data = {};
          //   vm.process_insp_select = 5;
          // }

          let ht_work_data = result_Data["ht_work_data"];
          vm.set_htWorkDataItem(ht_work_data);
        } else if (result["Response"] == "no data") {
          vm.set_alertMsg("查無資料");
          vm.settimeout_alertModal();
        } else {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
        }
      });
    },
    clear_select_workorderHistory() {
      let vm = this;
      vm.set_workorderHistoryCodeInformationItem([]);
      vm.set_workorderHistoryWireUseInformationItem([]);
      vm.set_headingProduceInformationItem([]);
      vm.set_produceInformationItem([]);
      vm.set_moldUseInformationItem([]);
      vm.set_threadUseInformationItem([]);
      vm.set_totalProduceTimeItem([]);
      vm.set_inspectionUseSingleProcess(true);
      vm.set_inspectionUseInformationData({});
      vm.clear_produceInformationPackageItem();
      vm.clear_workCodeInformationPackageItem();
      vm.clear_shipmentInformationItem();
      vm.clear_packageInformationItem();
      vm.clear_palletInformationItem();
      vm.clear_workorderHistoryPackageDataItem();
      vm.clear_containerInformationItem();
      vm.clear_containerTimeItem();
      vm.clear_containerDetailItem();
      vm.clear_containerShipmentItem();
    },
    resetExportCsv() {
      let vm = this;
      vm.set_exportData([]);
      vm.set_exportDataTitle([]);
      vm.set_exportFileName("");
    },
    setExportDataTitle() {
      let vm = this;
      let exportDataTitle = [];
      vm.csv_field_title.forEach((data) => {
        exportDataTitle.push(data.label);
      });
      vm.set_exportDataTitle(exportDataTitle);
    },
    machStatusImportAxios() {
      const axios = require("axios");
      this.machStatusAxios = axios;
    },
    machStatusAxiosCancel() {
      const CancelToken = this.machStatusAxios.CancelToken;
      const source = CancelToken.source();
      this.machStatusAxiosSource = source;
    },
    machStatusAxiosAction(params, functionName) {
      let vm = this;
      vm.machStatusAxios
        .post("/static/php/modules.php", params, {
          cancelToken: vm.machStatusAxiosSource.token,
        })
        .then(
          function (response) {
            const result = response.data;
            vm.machStatusAxiosResult(result, functionName);
          }.bind(this)
        )
        .catch(function (err) {
          console.log(err);
        });
    },
    machStatusAxiosResult(result, functionName) {
      let vm = this;
      console.log(functionName);
      console.log(result);
      if (functionName == "selectDevice") {
        if (!vm.first_load) {
          vm.hide_loadScreenModal();
          vm.first_load = true;
        }
        if (vm.sideBarSelect.process.name == "包裝") {
          vm.device_image = vm.package;
        } else if (vm.sideBarSelect.process.name == "出貨") {
          vm.device_image = vm.container;
        }
        if (result["Response"] == "ok" && result["page"] == "machstatus") {
          // vm.nowDeviceNumber = device;
          let result_Data = result["QueryTableData"];
          //機台資料
          if (vm.sideBarSelect.process.name == "包裝") {
            vm.device_detail = result_Data["pkg_detail"];
            vm.package_stack = result_Data["stack_bar_info"];
          } else if (vm.sideBarSelect.process.name == "出貨") {
            if (vm.shipment_process == "齊貨狀態") {
              vm.device_detail = result_Data["shipment_status"];
            } else if (vm.shipment_process == "裝櫃-即時狀態") {
              vm.device_detail = result_Data["container_status"];
            }
          } else {
            vm.device_detail.process = result_Data[0].process;
            vm.device_detail.group = result_Data[0].group;
            vm.device_detail.device_name = result_Data[0].device_name;
            vm.device_detail.device_model = result_Data[0].device_model;
            vm.device_detail.machine_status = result_Data[0].machine_status;
            vm.device_detail.device_run_time = result_Data[0].device_run_time;
            vm.device_detail.device_queue_time = result_Data[0].device_queue_time;
            vm.device_detail.device_activation =
              result_Data[0].device_activation;
            vm.device_detail.device_day_count = result_Data[0].device_day_count;
            vm.device_detail.device_capacity_min =
              result_Data[0].device_capacity_min;
            vm.device_image = vm[result_Data[0].machine_image];
          }

          if (vm.sideBarSelect.process.name == "熱處理") {
            vm.ht_work_code = result_Data[0].on_line_work;

            let work_code_information_item = [];
            let produce_information = [];
            if (vm.ht_work_code.length > 0) {
              if (vm.ht_work_current_view >= vm.ht_work_code.length) {
                vm.ht_work_current_view = 0;
              }
              let work_code_information =
                result_Data[0].on_line_work[vm.ht_work_current_view]
                  .work_code_information;
              if (work_code_information.length > 0) {
                work_code_information.forEach((data) => {
                  let work_code_information_obj = {};
                  work_code_information_obj["work_org_code"] =
                    data["work_org_code"];
                  // work_code_information_obj["code"] = {
                  //   code: data["work_code"],
                  //   org_code: data["work_org_code"],
                  // };
                  work_code_information_obj["productCode"] =
                    data["product_code"];
                  work_code_information_obj["control_card"] =
                    data["work_control_card"];
                  work_code_information_obj["product_chinese_name"] =
                    data["product_chinese_name"];
                  work_code_information_item.push(work_code_information_obj);
                });
                vm.percent_bar.work_code =
                  work_code_information[0]["work_code"];
              } else {
                vm.percent_bar.work_code = "";
              }
              vm.work_code_information_item = work_code_information_item;

              //生產資訊percent_bar
              produce_information =
                result_Data[0].on_line_work[vm.ht_work_current_view]
                  .produce_information;

              if (produce_information.length > 0) {
                vm.percent_bar.device_count =
                  produce_information[0].work_ht_in_weight;

                vm.percent_bar.device_out_count =
                  produce_information[0].work_out_weight;

                vm.percent_bar.work_qty =
                  produce_information[0].work_in_weight;

                vm.percent_bar.af_thd_weight =
                  produce_information[0].work_total_weight;

                vm.percent_bar.work_dispatch_weight =
                  produce_information[0].work_dispatch_weight;

                if (
                  vm.percent_bar.work_dispatch_weight == "-" ||
                  vm.percent_bar.af_thd_weight == "-"
                ) {
                  vm.percent_bar.thd_percent = "100.00";
                } else {
                  vm.percent_bar.thd_percent = (
                    (vm.percent_bar.af_thd_weight /
                      vm.percent_bar.work_dispatch_weight) *
                    100
                  ).toFixed(2);
                }

                if (vm.percent_bar.work_qty == "-") {
                  if (vm.percent_bar.device_count <= 0) {
                    vm.percent_bar.work_percent = 0;
                  } else {
                    vm.percent_bar.work_percent = 100;
                  }
                  if (vm.percent_bar.device_out_count <= 0) {
                    vm.percent_bar.work_out_percent = 0;
                  } else {
                    vm.percent_bar.work_out_percent = 100;
                  }
                } else {
                  let this_percent = (
                    (vm.percent_bar.device_count /
                      vm.percent_bar.work_dispatch_weight) *
                    100
                  ).toFixed(2);
                  vm.percent_bar.work_percent = this_percent;

                  let this_out_percent = (
                    (vm.percent_bar.device_out_count /
                      vm.percent_bar.work_dispatch_weight) *
                    100
                  ).toFixed(2);
                  vm.percent_bar.work_out_percent = this_out_percent;
                }
              }

              //每桶產出
              let bucket_information =
                result_Data[0].on_line_work[vm.ht_work_current_view]
                  .bucket_information;
              let bucket_information_item = [];
              if (bucket_information.length > 0) {
                bucket_information.forEach((data) => {
                  let bucket_information_obj = {};
                  bucket_information_obj["code"] = data["code"];
                  bucket_information_obj["furnaceCode"] = data["furnaceCode"];
                  bucket_information_obj["screwWeight"] = data["screwWeight"];
                  bucket_information_item.push(bucket_information_obj);
                });
              }
              vm.bucket_information_item = bucket_information_item;

              //總生產時間
              let total_produce_time_information =
                result_Data[0].on_line_work[vm.ht_work_current_view]
                  .total_produce_time_information;
              let total_produce_time_information_item = [];
              if (total_produce_time_information.length > 0) {
                total_produce_time_information.forEach((data) => {
                  let total_produce_time_information_obj = {};
                  total_produce_time_information_obj["code"] = data["code"];
                  total_produce_time_information_obj["device_name"] =
                    data["device_name"];
                  total_produce_time_information_obj["startTime"] =
                    data["startTime"];
                  total_produce_time_information_obj["endTime"] =
                    data["endTime"];
                  total_produce_time_information_obj["totalTime"] =
                    data["totalTime"];
                  total_produce_time_information_item.push(
                    total_produce_time_information_obj
                  );
                });
              }
              vm.total_produce_time_information_item =
                total_produce_time_information_item;
            } else {
              vm.work_code_information_item = work_code_information_item;
              vm.percent_bar.work_code = "";
              vm.percent_bar.device_count = 0;
              vm.percent_bar.work_qty = 0;
              vm.percent_bar.work_percent = 0;
              vm.bucket_information_item = [];
              vm.total_produce_time_information_item = [];
            }

            //堆疊圖
            // vm.device_detail.stack_bar_information =
            //   result_Data[0].stack_bar_information;
            vm.device_detail.ht_in_stack_information =
              result_Data[0].ht_in_stack_information;
            vm.device_detail.ht_out_stack_information =
              result_Data[0].ht_out_stack_information;

            //運轉日誌
            let operatelog_information = result_Data[0].operatelog_information;
            let operatelog_information_item = [];
            if (operatelog_information.length > 0) {
              operatelog_information.forEach((data) => {
                let operatelog_information_obj = {};
                // operatelog_obj["device_name"] = data["device_name"];
                // operatelog_obj["place_item"] = data["place_item"];
                // operatelog_obj["group_item"] = data["group_item"];
                // operatelog_obj["class_item"] = data["class_item"];
                operatelog_information_obj["status"] = data["status"];
                operatelog_information_obj["alarmCode"] = data["alarmCode"];
                operatelog_information_obj["alarmDetail"] = data["alarmDetail"];
                operatelog_information_obj["startTime"] = data["startTime"];
                operatelog_information_obj["endTime"] = data["endTime"];
                operatelog_information_obj["durationTime"] =
                  data["durationTime"];
                operatelog_information_item.push(operatelog_information_obj);
              });
            }
            vm.set_operateLogDataItem(operatelog_information_item);
            vm.operatelog_information_item = operatelog_information_item;
            // 如果是停在運轉日誌則更新;
            if (vm.tabIndex == 3) {
              vm.exportCsvData("operatelog");
            }

            // 如果是停在警報履歷則更新;
            if (vm.tabIndex == 4) {
              vm.exportCsvData("alarmhistory");
            }

            //機台燈號
            vm.machineItem_select = result_Data[0].machine_light_value;

            if (!vm.workorderHistory_row_click) {
              vm.set_workCodeInformationItem(vm.work_code_information_item);
              vm.set_bucketUseInformationItem(vm.bucket_information_item);
              vm.set_totalProduceTimeItem(
                vm.total_produce_time_information_item
              );

              //生產資訊
              vm.set_produceInformationHeatItem(produce_information);
            }
          } else if (vm.sideBarSelect.process.name == "包裝") {
            vm.set_produceInformationPackageItem(result_Data["product_info"]);
            vm.set_workCodeInformationPackageItem(
              result_Data["work_code_info"]
            );
            vm.set_shipmentInformationItem(result_Data["shipment_info"]);
            vm.set_packageInformationItem(result_Data["package_info"]);
            vm.set_palletInformationItem(result_Data["pallet_info"]);
          } else if (vm.sideBarSelect.process.name == "出貨") {
            if (vm.shipment_process == "齊貨狀態") {
              vm.set_containerShipmentItem(result_Data["shipment_data"]);
            } else if (vm.shipment_process == "裝櫃-即時狀態") {
              vm.set_containerInformationItem(
                result_Data["container_information"]
              );
              vm.set_containerDetailItem(result_Data["container_detail"]);
              vm.set_containerTimeItem(result_Data["container_time"]);
            }
          } else {
            //工單基本資料
            let work_code_information = result_Data[0].work_code_information;
            let work_code_information_item = [];
            if (work_code_information.length > 0) {
              work_code_information.forEach((data) => {
                let work_code_information_obj = {};
                work_code_information_obj["work_org_code"] =
                  data["work_org_code"];
                // work_code_information_obj["code"] = {
                //   code: data["work_code"],
                //   org_code: data["work_org_code"],
                // };
                work_code_information_obj["productCode"] = data["product_code"];
                work_code_information_obj["control_card"] =
                  data["work_control_card"];
                work_code_information_obj["product_chinese_name"] =
                  data["product_chinese_name"];
                work_code_information_item.push(work_code_information_obj);
              });
              vm.percent_bar.work_code = work_code_information[0]["work_code"];
            } else {
              vm.percent_bar.work_code = "";
            }
            vm.work_code_information_item = work_code_information_item;

            //堆疊圖
            vm.device_detail.stack_bar_information =
              result_Data[0].stack_bar_information;

            if (result_Data[0].produce_information.length > 0) {
              vm.percent_bar.device_count =
                result_Data[0].produce_information[0]["qty"]["count"];
              vm.percent_bar.work_qty =
                result_Data[0].produce_information[1]["qty"]["count"];

              if (vm.percent_bar.work_qty != 0) {
                let this_percent = (
                  (vm.percent_bar.device_count / vm.percent_bar.work_qty) *
                  100
                ).toFixed(2);
                this_percent > 100 ? (this_percent = 100) : "";
                vm.percent_bar.work_percent = this_percent;
              }
            }

            if (vm.sideBarSelect.process.name == "打頭") {
              //使用線材
              let wire_information = result_Data[0].wire_information;
              let wire_information_item = [];
              if (wire_information.length > 0) {
                wire_information.forEach((data) => {
                  let wire_information_obj = {};
                  wire_information_obj["code"] = data["code"];
                  wire_information_obj["chinese_name"] = data["chinese_name"];
                  wire_information_obj["scroll_no"] = data["scroll_no"];
                  wire_information_obj["furnaceCode"] = data["furnaceCode"];
                  wire_information_obj["start_weight"] = data["start_weight"];
                  wire_information_obj["remain_weight"] = data["remain_weight"];
                  wire_information_obj["consumption"] = data["consumption"];
                  // wire_information_obj["attrition"] = data["attrition"];
                  wire_information_item.push(wire_information_obj);
                });
                let wire_information_obj = {};
                wire_information_obj["start_weight"] = "";
                wire_information_obj["remain_weight"] = "總計";
                wire_information_obj["consumption"] =
                  result_Data[0].wire_total_weight;
                // wire_information_obj["attrition"] =
                //   result_Data[0].wire_lose_rate;
                wire_information_item.push(wire_information_obj);
              }
              vm.wire_information_item = wire_information_item;

              //使用模具
              let mould_information = result_Data[0].mould_information;
              let mould_information_item = [];
              if (mould_information.length > 0) {
                mould_information.forEach((data) => {
                  let mould_information_obj = {};
                  mould_information_obj["code"] = data["code"];
                  mould_information_obj["seriesNo"] = data["seriesNo"];
                  mould_information_obj["name"] = data["name"];
                  mould_information_obj["used_life"] = data["used_life"];
                  mould_information_obj["standard_life"] =
                    data["standard_life"];
                  mould_information_item.push(mould_information_obj);
                });
              }
              vm.mould_information_item = mould_information_item;

              let remainWorkCodeItem = [];
              let remain_work_order_information =
                result_Data[0].remain_work_order_information;
              if (remain_work_order_information.length > 0) {
                remain_work_order_information.forEach((data) => {
                  let remain_work_order_information_obj = {};
                  remain_work_order_information_obj["work_org_code"] =
                    data["work_org_code"];
                  // remain_work_order_information_obj["code"] = {
                  //   code: data["work_code"],
                  //   org_code: data["work_org_code"],
                  // };
                  remain_work_order_information_obj["productCode"] =
                    data["product_code"];
                  remain_work_order_information_obj["control_card"] =
                    data["work_control_card"];
                  remain_work_order_information_obj["product_chinese_name"] =
                    data["product_chinese_name"];
                  remain_work_order_information_obj["mouldCode"] =
                    data["mould_code"];
                  remain_work_order_information_obj["workQty"] =
                    data["work_qty"];
                  remain_work_order_information_obj["workStandWeight"] =
                    data["work_stand_weight"].toFixed(0);
                  remainWorkCodeItem.push(remain_work_order_information_obj);
                });
              }
              vm.remainWorkCodeItem = remainWorkCodeItem;
            } else if (vm.sideBarSelect.process.name == "輾牙") {
              //使用牙板
              let thread_information = result_Data[0].thread_information;
              let thread_information_item = [];
              if (thread_information.length > 0) {
                thread_information.forEach((data) => {
                  let thread_information_obj = {};
                  thread_information_obj["code"] = data["code"];
                  thread_information_obj["seriesNo"] = data["seriesNo"];
                  thread_information_obj["name"] = data["name"];
                  thread_information_obj["used_life"] = data["used_life"];
                  thread_information_obj["standard_life"] =
                    data["standard_life"];
                  thread_information_item.push(thread_information_obj);
                });
              }
              vm.thread_information_item = thread_information_item;
            }

            //每桶產出
            let bucket_information = result_Data[0].bucket_information;
            let bucket_information_item = [];
            if (bucket_information.length > 0) {
              bucket_information.forEach((data) => {
                let bucket_information_obj = {};
                bucket_information_obj["code"] = data["code"];
                bucket_information_obj["furnaceCode"] = data["furnaceCode"];
                bucket_information_obj["screwWeight"] = data["screwWeight"];
                bucket_information_item.push(bucket_information_obj);
              });
            }
            vm.bucket_information_item = bucket_information_item;

            //檢驗資料
            inspection_information;
            let inspection_information = result_Data[0].inspection_information;
            vm.inspection_information = inspection_information;

            //總生產時間
            let total_produce_time_information =
              result_Data[0].total_produce_time_information;
            let total_produce_time_information_item = [];
            if (total_produce_time_information.length > 0) {
              total_produce_time_information.forEach((data) => {
                let total_produce_time_information_obj = {};
                total_produce_time_information_obj["code"] = data["code"];
                total_produce_time_information_obj["device_name"] =
                  data["device_name"];
                total_produce_time_information_obj["startTime"] =
                  data["startTime"];
                total_produce_time_information_obj["endTime"] = data["endTime"];
                total_produce_time_information_obj["totalTime"] =
                  data["totalTime"];
                total_produce_time_information_item.push(
                  total_produce_time_information_obj
                );
              });
            }
            vm.total_produce_time_information_item =
              total_produce_time_information_item;

            //運轉日誌
            let operatelog_information = result_Data[0].operatelog_information;
            let operatelog_information_item = [];
            if (operatelog_information.length > 0) {
              operatelog_information.forEach((data) => {
                let operatelog_information_obj = {};
                // operatelog_obj["device_name"] = data["device_name"];
                // operatelog_obj["place_item"] = data["place_item"];
                // operatelog_obj["group_item"] = data["group_item"];
                // operatelog_obj["class_item"] = data["class_item"];
                operatelog_information_obj["status"] = data["status"];
                operatelog_information_obj["alarmCode"] = data["alarmCode"];
                operatelog_information_obj["alarmDetail"] = data["alarmDetail"];
                operatelog_information_obj["startTime"] = data["startTime"];
                operatelog_information_obj["endTime"] = data["endTime"];
                operatelog_information_obj["durationTime"] =
                  data["durationTime"];
                operatelog_information_item.push(operatelog_information_obj);
              });
            }
            vm.set_operateLogDataItem(operatelog_information_item);
            vm.operatelog_information_item = operatelog_information_item;
            // 如果是停在運轉日誌則更新;
            if (vm.tabIndex == 4 && vm.sideBarSelect.process.name == "打頭") {
              vm.exportCsvData("operatelog");
            } else if (
              vm.tabIndex == 3 &&
              vm.sideBarSelect.process.name == "輾牙"
            ) {
              vm.exportCsvData("operatelog");
            }

            //機台燈號
            vm.machineItem_select = result_Data[0].machine_light_value;

            //警報履歷
            vm.alarmHistory_information =
              result_Data[0].alarmHistory_information;
            let alarmHistory_information =
              result_Data[0].alarmHistory_information;
            let alarmHistory_information_item = [];
            if (alarmHistory_information.length > 0) {
              alarmHistory_information.forEach((data) => {
                let alarmHistory_information_obj = {};
                alarmHistory_information_obj["alarmCode"] = data["alarmCode"];
                alarmHistory_information_obj["alarmDetail"] =
                  data["alarmDetail"];
                alarmHistory_information_obj["alarmVideo"] = data["alarmVideo"];
                alarmHistory_information_obj["startTime"] = data["startTime"];
                alarmHistory_information_obj["endTime"] = data["endTime"];
                alarmHistory_information_obj["continuousTime"] =
                  data["continuousTime"];
                alarmHistory_information_item.push(
                  alarmHistory_information_obj
                );
              });
            }
            vm.alarmHistory_information_item = alarmHistory_information_item;
            // 如果是停在警報履歷則更新;
            if (vm.tabIndex == 5 && vm.sideBarSelect.process.name == "打頭") {
              vm.set_alarmHistoryDataItem(vm.alarmHistory_information);
              vm.exportCsvData("alarmhistory");
            } else if (
              vm.tabIndex == 4 &&
              vm.sideBarSelect.process.name == "輾牙"
            ) {
              vm.set_alarmHistoryDataItem(vm.alarmHistory_information);
              vm.exportCsvData("alarmhistory");
            }

            if (!vm.workorderHistory_row_click) {
              vm.set_workCodeInformationItem(vm.work_code_information_item);
              console.log(vm.work_code_information_item);
              if (vm.sideBarSelect.process.name == "打頭") {
                vm.set_wireUseInformationItem(vm.wire_information_item);
                vm.set_produceInformationHeadItem(
                  result_Data[0].produce_information
                );
                vm.set_moldUseInformationItem(vm.mould_information_item);
              } else if (vm.sideBarSelect.process.name == "輾牙") {
                vm.set_produceInformationThreadItem(
                  result_Data[0].produce_information
                );
                console.log(result_Data[0].produce_information);
                vm.set_threadUseInformationItem(vm.thread_information_item);
              }
              vm.set_bucketUseInformationItem(vm.bucket_information_item);
              vm.set_inspectionUseSingleProcess(true);
              vm.set_inspectionUseInformationData(vm.inspection_information);
              vm.set_totalProduceTimeItem(
                vm.total_produce_time_information_item
              );
            }
          }
        } else if (result["Response"] == "no data") {
          vm.set_alertMsg("查無資料");
        } else {
          vm.set_alertMsg(result["Response"]);
        }
        vm.query_counter++;
        vm.getNowTime();
        vm.main_query_check = true;
        vm.timer_selectDevice = setTimeout(function () {
          if (vm.this_device_name != "") {
            vm.selectDevice(vm.this_device_name);
          } else if (device_name != "") {
            vm.selectDevice(vm.device_name);
          }
        }, 1000);
      }
    },
    clearTimer(timerName) {
      if (timerName === "undefined") {
        var highestIntervalId = setInterval(";");
        for (var i = 0; i < highestIntervalId; i++) {
          //清除所有計時資料
          clearInterval(i);
        }
      } else {
        clearTimeout(timerName);
      }
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
    selectWorkCodeInfo(index) {
      let vm = this;
      vm.ht_work_current_view = index;
      //工單資訊
      let work_code_information = vm.ht_work_code[index].work_code_information;
      let work_code_information_item = [];
      if (work_code_information.length > 0) {
        work_code_information.forEach((data) => {
          let work_code_information_obj = {};
          work_code_information_obj["work_org_code"] = data["work_org_code"];
          // work_code_information_obj["code"] = {
          //   code: data["work_code"],
          //   org_code: data["work_org_code"],
          // };
          work_code_information_obj["productCode"] = data["product_code"];
          work_code_information_obj["control_card"] = data["work_control_card"];
          work_code_information_obj["product_chinese_name"] =
            data["product_chinese_name"];
          work_code_information_item.push(work_code_information_obj);
        });
        vm.percent_bar.work_code = work_code_information[0]["work_code"];
      } else {
        vm.percent_bar.work_code = "";
      }
      vm.work_code_information_item = work_code_information_item;

      //生產資訊percent_bar

      let produce_information = vm.ht_work_code[index].produce_information;

      if (produce_information.length > 0) {
        vm.percent_bar.device_count = produce_information[0].work_ht_in_weight;
        vm.percent_bar.device_out_count =
          produce_information[0].work_out_weight;
        vm.percent_bar.work_qty = produce_information[0].work_in_weight;
        vm.percent_bar.work_dispatch_weight =
          produce_information[0].work_dispatch_weight;
        vm.percent_bar.af_thd_weight = produce_information[0].work_total_weight;

        if (
          vm.percent_bar.work_dispatch_weight == "-" ||
          vm.percent_bar.af_thd_weight == "-"
        ) {
          vm.percent_bar.thd_percent = "100.00";
        } else {
          vm.percent_bar.thd_percent = (
            (vm.percent_bar.af_thd_weight /
              vm.percent_bar.work_dispatch_weight) *
            100
          ).toFixed(2);
        }

        if (vm.percent_bar.work_qty == "-") {
          if (vm.percent_bar.device_count <= 0) {
            vm.percent_bar.work_percent = 0;
          } else {
            vm.percent_bar.work_percent = 100;
          }
          if (vm.percent_bar.device_out_count <= 0) {
            vm.percent_bar.work_out_percent = 0;
          } else {
            vm.percent_bar.work_out_percent = 100;
          }
        } else {
          let this_percent = (
            (vm.percent_bar.device_count /
              vm.percent_bar.work_dispatch_weight) *
            100
          ).toFixed(2);
          vm.percent_bar.work_percent = this_percent;

          let this_out_percent = (
            (vm.percent_bar.device_out_count /
              vm.percent_bar.work_dispatch_weight) *
            100
          ).toFixed(2);
          vm.percent_bar.work_out_percent = this_out_percent;
        }
      }

      //每桶產出
      let bucket_information = vm.ht_work_code[index].bucket_information;
      let bucket_information_item = [];
      if (bucket_information.length > 0) {
        bucket_information.forEach((data) => {
          let bucket_information_obj = {};
          bucket_information_obj["code"] = data["code"];
          bucket_information_obj["furnaceCode"] = data["furnaceCode"];
          bucket_information_obj["screwWeight"] = data["screwWeight"];
          bucket_information_item.push(bucket_information_obj);
        });
      }
      vm.bucket_information_item = bucket_information_item;

      //總生產時間
      let total_produce_time_information =
        vm.ht_work_code[index].total_produce_time_information;
      let total_produce_time_information_item = [];
      if (total_produce_time_information.length > 0) {
        total_produce_time_information.forEach((data) => {
          let total_produce_time_information_obj = {};
          total_produce_time_information_obj["code"] = data["code"];
          total_produce_time_information_obj["device_name"] =
            data["device_name"];
          total_produce_time_information_obj["startTime"] = data["startTime"];
          total_produce_time_information_obj["endTime"] = data["endTime"];
          total_produce_time_information_obj["totalTime"] = data["totalTime"];
          total_produce_time_information_item.push(
            total_produce_time_information_obj
          );
        });
      }
      vm.total_produce_time_information_item =
        total_produce_time_information_item;

      if (!vm.workorderHistory_row_click) {
        vm.set_workCodeInformationItem(vm.work_code_information_item);
        vm.set_bucketUseInformationItem(vm.bucket_information_item);
        vm.set_totalProduceTimeItem(vm.total_produce_time_information_item);

        //生產資訊
        vm.set_produceInformationHeatItem(
          vm.ht_work_code[index].produce_information
        );
      }
    },
    toPreviousPage() {
      let vm = this;
      if (vm.previousPage.pageStatus) {
        vm.set_sideBarSelect(vm.previousPage.pageName);
        vm.change_selectPage(vm.previousPage.pageName);
        vm.change_selectPageName(vm.pageName.home);
        vm.clear_previousPage();
        vm.$router.push("/index/home");
      }
    },
    exportCsvData(whichProgram) {
      let vm = this;
      let todayStr =
        new Date().getFullYear() +
        ("0" + (new Date().getMonth() + 1)).slice(-2) +
        ("0" + new Date().getDate()).slice(-2);
      let exportFileName = "";

      switch (whichProgram) {
        case "operatelog":
          if (vm.operatelog_information_item.length > 0) {
            vm.set_exportData(vm.operatelog_information_item);
            vm.csv_field_title = vm.operateLogDataFields;
            vm.setExportDataTitle();
            exportFileName = "運轉日誌_" + vm.device_name + "_" + todayStr;
            vm.set_exportFileName(exportFileName);
            break;
          } else {
            vm.resetExportCsv();
          }
        case "alarmhistory":
          if (vm.alarmHistory_information_item.length > 0) {
            vm.set_exportData(vm.alarmHistory_information_item);
            vm.csv_field_title = vm.alarmHistoryDataFields;
            vm.setExportDataTitle();
            exportFileName = "警報履歷_" + vm.device_name + "_" + todayStr;
            vm.set_exportFileName(exportFileName);
          } else {
            vm.resetExportCsv();
          }
          break;
      }
    },
    setSessionItems() {
      sessionStorage.setItem("mes_elecboard_process_id", this.process_id);
      sessionStorage.setItem("mes_elecboard_group_id", this.group_id);
      sessionStorage.setItem(
        "mes_machStatus_this_device_name",
        this.this_device_name
      );
      sessionStorage.setItem("mes_machStatus_tabIndex", this.tabIndex);
      sessionStorage.setItem(
        "mes_machStatus_previousPageName",
        this.previousPageName
      );
      sessionStorage.setItem(
        "mes_machStatus_shipmentProcess",
        this.shipment_process
      );
    },
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.setSessionItems);
    this.machStatusAxiosSource.cancel("back");
    this.clearTimer(this.timer_selectDevice);
    this.clearTimer();
    this.clear_machineHealthData();
    this.clear_workCodeInformationItem();
    this.clear_wireUseInformationItem();
    this.clear_moldUseInformationItem();
    this.clear_threadUseInformationItem();
    this.clear_bucketUseInformation();
    this.clear_inspectionUseInformation();
    this.clear_operateLogDataItem();
    this.clear_workorderHistoryDataItem();
    this.clear_alarmHistoryDataItem();
    this.clear_previousPage();
    this.clear_produceInformationPackageItem();
    this.clear_workCodeInformationPackageItem();
    this.clear_shipmentInformationItem();
    this.clear_packageInformationItem();
    this.clear_palletInformationItem();
    this.clear_workorderHistoryPackageDataItem();
    this.clear_containerInformationItem();
    this.clear_containerTimeItem();
    this.clear_containerDetailItem();
    this.clear_containerShipmentItem();
    this.clear_shipmentProcess();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.machStatus-place-button p {
  border-radius: 5px;
  background-color: #4b8c80;
  color: #ffffff;
  padding: 0px 13px;
  width: 4.25rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0 0 0 0.5rem;
  cursor: pointer;
}

.machStatus-back-button {
  float: right;
}
.machStatus-back-button p {
  border-radius: 5px;
  background-color: #4b8c80;
  color: #ffffff;
  padding: 0px 13px;
  width: 4.25rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0 0 0 0.5rem;
  cursor: pointer;
}
/* .machStatus-detail div div p {
  font-size: 16px;
  margin-bottom: 0.3rem;
} */
.ht_work_code_active {
  background-color: #4b8c80 !important;
  border-color: #4b8c80 !important;
}
</style>
<style lang="scss">
.input-group-text {
  background-color: #4b8c80;
  color: #ffffff;
}
.input-group > input {
  background-color: #cccccc !important;
  border-color: #cccccc;
}
.nav-tabs .nav-link {
  width: 140px;
  margin-right: 0.5rem;
  border-radius: 0.75rem 0.75rem 0 0;
}
.nav-tabs .nav-link.active,
.nav-tabs .show > .nav-link {
  background-color: #4b8c80;
  color: #ffffff;
}
.nav-tabs .nav-link,
.nav-tabs .show > .nav-link {
  background-color: #999999;
  color: #ffffff;
}
.nav-tabs > .nav-item > a {
  font-size: 1rem;
  font-family: dfyuanstd-w5, dfyuanstd-w3;
}
.nav-tabs {
  border-bottom: none;
}
.MachStatus .customize-tab {
  background-color: #f2f2f2;
}
.MachStatus .customize-tab > div:nth-child(1) {
  background-color: #ffffff;
}

.machStatus-components-table > table > thead > tr > th {
  z-index: 1 !important;
}
.machStatus-components-table th,
.machStatus-components-table td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.machStatus-components-table td {
  font-size: 1rem;
}
.machStatus-components-table th:first-child,
.machStatus-components-table td:first-child {
  border-left: 1px solid;
}
.machStatus-components-table thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.machStatus-components-table tr {
  background-color: #ffffff;
}
.machStatus-components-table-workorderHistory > table > thead > tr > th {
  z-index: 1 !important;
}
.machStatus-components-table-workorderHistory th,
.machStatus-components-table-workorderHistory td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.machStatus-components-table-workorderHistory td {
  font-size: 1rem;
}
.machStatus-components-table-workorderHistory th:first-child,
.machStatus-components-table-workorderHistory td:first-child {
  border-left: 1px solid;
}
.machStatus-components-table-workorderHistory thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.machStatus-components-table-workorderHistory tr {
  background-color: #ffffff;
}
.machStatus-components-table-workorderHistory tr th:nth-child(1),
.machStatus-components-table-workorderHistory tr td:nth-child(1) {
  width: 8.5rem;
  min-width: 8.5rem;
}
.machStatus-components-table-workorderHistory tr th:nth-child(2),
.machStatus-components-table-workorderHistory tr td:nth-child(2) {
  width: 20rem;
  min-width: 20rem;
}
.machStatus-components-table-workorderHistory tr th:nth-child(3),
.machStatus-components-table-workorderHistory tr td:nth-child(3) {
  width: 10.5rem;
  min-width: 10.5rem;
}
.machStatus-components-table-workorderHistory tr th:nth-child(4),
.machStatus-components-table-workorderHistory tr td:nth-child(4) {
  width: 10.5rem;
  min-width: 10.5rem;
}
.machStatus-components-table-workorderHistory tr th:nth-child(5),
.machStatus-components-table-workorderHistory tr td:nth-child(5) {
  width: 9rem;
  min-width: 9rem;
}
.machStatus-components-table-workorderHistory tr th:nth-child(6),
.machStatus-components-table-workorderHistory tr td:nth-child(6) {
  width: 10.5rem;
  min-width: 10.5rem;
}
.machStatus-components-table-workorderHistory tr th:nth-child(7),
.machStatus-components-table-workorderHistory tr td:nth-child(7) {
  width: 10.5rem;
  min-width: 10.5rem;
}

.remainWorkCode-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.remainWorkCode-table-detail th,
.remainWorkCode-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.remainWorkCode-table-detail td {
  font-size: 1rem;
}
.remainWorkCode-table-detail th:first-child,
.remainWorkCode-table-detail td:first-child {
  border-left: 1px solid;
}
.remainWorkCode-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.remainWorkCode-table-detail tr {
  background-color: #ffffff;
}
.remainWorkCode-table-detail tr th:nth-child(1),
.remainWorkCode-table-detail tr td:nth-child(1) {
  width: 6rem;
  min-width: 6rem;
}
.remainWorkCode-table-detail tr th:nth-child(2),
.remainWorkCode-table-detail tr td:nth-child(2) {
  width: 9rem;
  min-width: 9rem;
}
.remainWorkCode-table-detail tr th:nth-child(3),
.remainWorkCode-table-detail tr td:nth-child(3) {
  width: 14rem;
  min-width: 14rem;
}
.remainWorkCode-table-detail tr th:nth-child(4),
.remainWorkCode-table-detail tr td:nth-child(4) {
  width: 35.5rem;
  min-width: 35.5rem;
}
.remainWorkCode-table-detail tr th:nth-child(5),
.remainWorkCode-table-detail tr td:nth-child(5) {
  width: 9rem;
  min-width: 9rem;
}
.remainWorkCode-table-detail tr th:nth-child(6),
.remainWorkCode-table-detail tr td:nth-child(6) {
  width: 6rem;
  min-width: 6rem;
}

.stackBarTitle {
  width: 7rem;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}
.stackBarContent {
  width: calc(100% - 7.5rem);
  display: inline-block;
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/views/MachStatus.vue